import {
  IMAGE_CDN_ORIGIN,
  businessType,
  businessTypeCN,
  asogrowCN,
  languageAll,
  languageAllCN,
  countrySupport,
  countrySupportCN,
  languageGuaranteed,
  languageGuaranteedCN,
  countryAll,
  timezone,
  mediaOptions,
} from '@/js/varible'
import isInteger from 'lodash/isInteger'
import dayjs from 'dayjs'
import Qs from 'qs'
import { easeMoveTo, funCalc, getCookie } from '@common/js/common'
import { guide } from '@/js/intro'
import { omit } from 'lodash'
import moment from 'moment'
import { throttleFn } from '@/js/common'
import { normalizeReviewRows } from '@/js/customReview'

export default {
  data() {
    return {
      asogrowCN,
      mannerTagsEN: [
        'Positive',
        'Satisfied',
        'Sincere',
        'Enthusiastic',
        'Praising',
        'Recommended',
        'Concise',
        'Impressed',
        'Warm',
        'Heartfelt',
        'Casual',
        'Grateful',
        'Delighted',
        'Frank',
        'Gentle',
        'Surprised',
        'Admiring',
        'Efficient',
        'Friendly',
        'Reliable',
      ],
      mannerTagsCN: [
        '积极',
        '满意',
        '真诚',
        '热情',
        '赞扬',
        '推荐',
        '简洁',
        '印象',
        '感人',
        '发自内心',
        '轻松随意',
        '感激',
        '高兴',
        '坦率',
        '温和',
        '惊喜',
        '欣赏',
        '高效',
        '友好',
        '可靠',
      ],
      use_total_price_discount: 0,
      resizedImageFileList: [],
      targetWidth: 912,
      targetHeight: 400,
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      costReportData: {
        cap: {},
        total: {},
        cost: {},
        file_url: '',
        discount_type: 0,
        cap_int: {},
        unit_price_after_discount: {},
        unit_price_before_discount: {},
        order_price_str: '',
      },
      aiForm: {
        app_id: '',
        name: '',
        package: '',
        summary: '',
        language: 'US',
        limit_reviews: 30,
        additional_requirements: '',
        video_summary: '',
        emoji: 1,
      },
      aiFeedback: {
        id: '',
        like: '',
        comment: '',
      },
      aiReviews: [],
      selectedReviews: [],
      aiRules: {
        language: [],
        limit_reviews: [
          {
            trigger: 'blur',
            required: false,
            validator: (rule, value, callback) => {
              if (value < 1 || value > 100) {
                /* eslint-disable standard/no-callback-literal */
                callback(new Error(this.$t('messages.tipError.notNumErr')))
                return
              }
              callback()
            },
          },
        ],
        video_summary: [
          {
            trigger: 'blur',
            required: false,
            validator: (rule, value, callback) => {
              if (value.length > 200) {
                /* eslint-disable standard/no-callback-literal */
                callback(new Error(this.$t('messages.tipError.limitErr2')))
                return
              }
              callback()
            },
          },
        ],
        additional_requirements: [
          {
            trigger: 'blur',
            required: false,
            validator: (rule, value, callback) => {
              if (value.length > 200) {
                /* eslint-disable standard/no-callback-literal */
                callback(new Error(this.$t('messages.tipError.limitErr2')))
                return
              }
              callback()
            },
          },
        ],
      },
      rules: {
        review_helpfulness_vote: [
          { required: true, message: 'Vaule should not be empty.', trigger: ['blur', 'change'] },
        ],
        package: [
          {
            trigger: ['blur', 'change'],
            required: false,
            validator: (rule, value, callback) => {
              if (!value) {
                /* eslint-disable standard/no-callback-literal */
                callback(new Error(this.$t('messages.tipError.emptyErr')))
                return
              }
              callback()
            },
          },
        ],
        app_name: [
          {
            trigger: ['blur', 'change'],
            required: false,
            validator: (rule, value, callback) => {
              if (!value) {
                /* eslint-disable standard/no-callback-literal */
                callback(new Error(this.$t('messages.tipError.emptyErr')))
                return
              }
              callback()
            },
          },
        ],
        icon: [
          {
            trigger: ['blur', 'change'],
            required: false,
            validator: (rule, value, callback) => {
              if (!value) {
                /* eslint-disable standard/no-callback-literal */
                callback(new Error(this.$t('messages.tipError.emptyErr')))
                return
              }
              callback()
            },
          },
        ],
        country: [
          {
            validator: (rule, value, callback) => {
              // 新手试用开启，判断是否是非JD国家
              // 除 keyword install这个类型外，判断是否是非JD国家
              let { business_type, country } = this.form
              if (!value) {
                callback(new Error(this.$t('messages.createCampaign.create10')))
                return
              }
              let arr = ['US', 'BD', 'PK']
              let arr2 = ['BD', 'PK']
              if (this.isOfflineTypeAllComputed && arr.includes(country)) {
                callback(new Error(this.$t('messages.createCampaign.create53')))
                return
              }
              if (business_type === 4 && arr2.includes(country) && !this.isCombo) {
                callback(new Error(this.$t('messages.createCampaign.create53')))
                return
              }
              if (this.newCountry || this.asoCountry) {
                // let arr = [3,7]
                let arr = [3, ...this.reviewsTypes]
                if (this.freeTrialUse) {
                  callback(new Error(this.$t('messages.createCampaign.create56')))
                  return
                } else if (arr.includes(business_type)) {
                  callback()
                } else {
                  /* eslint-disable standard/no-callback-literal */
                  //  callback('The current business type is not available in this country.')
                  callback()
                }
              } else if (
                (this.freeTrialUse ||
                  (business_type !== 2 && business_type !== 0) ||
                  this.form.cp_type === 1) &&
                this.otherCountry
              ) {
                if (this.freeTrialUse) {
                  /* eslint-disable standard/no-callback-literal */
                  callback(new Error(this.$t('messages.createCampaign.create56')))
                  return
                } else {
                  /* eslint-disable standard/no-callback-literal */
                  // callback('The current business type is not available in this country.')
                  callback()
                }
              }
              callback()
            },
            trigger: 'change',
          },
        ],
        tz: [],
        schedule: [this.createRequiredRule(this, 'messages.tipError.emptyErr')],
        img: [this.createRequiredRule(this, 'messages.tipError.emptyErr')],
        review_url: [
          this.createRequiredRule(this, 'messages.tipError.emptyErr'),
          this.createRequiredRule2(this, 'messages.gLogin.urlErr', undefined, 'url'),
          // { type: 'url', message: this.$t('messages.gLogin.urlErr'), trigger: ['blur', 'change'] },
        ],
        reviewer_name: [this.createRequiredRule(this, 'messages.tipError.emptyErr')],
        review_screenshot: [this.createRequiredRule(this, 'messages.tipError.emptyErr')],
        cp_type: [this.createRequiredRule(this, 'messages.tipError.emptyErr')],
        avatar: [this.createRequiredRule(this, 'messages.tipError.emptyErr')],
        post_banner: [this.createRequiredRule(this, 'messages.tipError.emptyErr')],
        promotion_days: [this.createRequiredRule(this, 'messages.tipError.emptyErr')],
        media_platform: [],
        media_target: [],
        comments_file: [this.createRequiredRule(this, 'messages.createCampaign.create135')],
        lang: [this.createRequiredRule(this, 'messages.createCampaign.create136')],
        user_category: [this.createRequiredRule(this, 'messages.tipError.emptyErr')],
        product_feature: [this.createRequiredRule(this, 'messages.tipError.emptyErr')],
        attitude: [this.createRequiredRule(this, 'messages.tipError.emptyErr')],
        app_store_url: [
          this.createRequiredRule(this, 'messages.tipError.emptyErr'),
          {
            validator: (rule, value, callback) => {
              let newUrl = value
              let arr = []
              arr = this.applications.filter(i => i.app_store_url === newUrl)
              if (arr.length > 0) {
                this.selectObj.imgUrl = arr[0].icon_url
                this.selectObj.country = arr[0].country
                this.selectObj.name = arr[0].app_name

                // this.form.icon = arr[0].icon_url
                // this.form.country = arr[0].country
                this.form.app_name = arr[0].app_name
                this.initOneImage(arr[0].icon_url, 'iconFileList')
              }
              callback()
            },
            trigger: 'change',
          },
        ],
        business_type: [
          this.createRequiredRule(this, 'messages.createCampaign.create139'),
          {
            validator: (rule, value, callback) => {
              if (this.otherCountry && (value === 4 || value === 5)) {
                /* eslint-disable standard/no-callback-literal */
                callback(new Error(this.$t('messages.createCampaign.create125')))
                return
              }
              callback()
            },
            trigger: ['blur', 'change'],
          },
        ],
      },
      dailyCapRules: [
        this.createRequiredRule(this, 'messages.tipError.emptyErr'),
        {
          validator: (rule, value, callback) => {
            if (this.freeTrialUse) {
              if (value > 5) {
                /* eslint-disable standard/no-callback-literal */
                callback(new Error(this.$t('messages.createCampaign.create101')))
              } else {
                callback()
              }
            } else {
              if (value < 3 && !this.reviewsTypesAndYtbCommentComputed) {
                /* eslint-disable standard/no-callback-literal */
                callback(new Error(this.$t('messages.tipError.capErr')))
              } else {
                callback()
              }
              // AAN-9441
              // if (value < 1 && this.reviewsTypesAndYtbCommentComputed (business_type !== 7 && business_type !== 11)) {
              //   /* eslint-disable standard/no-callback-literal */
              //   callback('Please fill in an integer.')
              // } else {
              //   callback()
              // }
            }
          },
          trigger: 'blur',
        },
      ],
      totalCapRules: [
        this.createRequiredRule(this, 'messages.tipError.emptyErr'),
        {
          validator: (rule, value, callback) => {
            if (this.freeTrialUse) {
              if (value > 5) {
                /* eslint-disable standard/no-callback-literal */

                callback(new Error(this.$t('messages.createCampaign.create101'))) // The maximum free cap is 5.
              } else {
                callback()
              }
            } else {
              // 9441
              // if (value < 1 && (business_type !== 7 && business_type !== 11)) {
              //   /* eslint-disable standard/no-callback-literal */
              //   callback('Please fill in an integer.')
              // } else {

              //   callback()
              // }
              if (value < 1 && !this.reviewsTypesAndYtbCommentComputed) {
                /* eslint-disable standard/no-callback-literal */
                callback(new Error(this.$t('messages.createCampaign.create22')))
              } else {
                callback()
              }
            }
          },
          trigger: 'blur',
        },
      ],
      samplePictureRules: [this.createRequiredRule(this, 'messages.tipError.emptyErr')],
      typeNewPrice: {
        1: [
          {
            name: 'Download,Open',
            ID: 0.2,
            IN: 0.2,
            PH: 0.23,
            US: 1.0,
            Other: 0.16,
            NG: 0.2,
            VN: 0.23,
            TH: 0.23,
            BR: 0.23,
            MX: 0.3,
            MY: 0.35,
            BD: 0.23,
            PK: 0.23,
          },
        ],
        2: [
          {
            name: 'Search Keyword,Install and Open',
            ID: 0.23,
            IN: 0.23,
            PH: 0.25,
            US: 1.2,
            Other: 0.18,
            NG: 0.23,
            VN: 0.25,
            TH: 0.25,
            BR: 0.26,
            MX: 0.32,
            MY: 0.38,
            BD: 0.25,
            PK: 0.25,
          },
        ],
        3: [
          {
            name: 'Download,Open',
            ID: 0.2,
            IN: 0.2,
            PH: 0.23,
            US: 1.0,
            Other: 0.16,
            NG: 0.2,
            VN: 0.23,
            TH: 0.23,
            BR: 0.23,
            MX: 0.3,
            MY: 0.35,
            BD: 0.23,
            PK: 0.23,
          },
          {
            name: 'Rating',
            ID: 0.25,
            IN: 0.25,
            PH: 0.25,
            US: 0.5,
            Other: 0.1,
            NG: 0.25,
            VN: 0.25,
            TH: 0.25,
            BR: 0.27,
            MX: 0.25,
            MY: 0.25,
            BD: 0.25,
            PK: 0.25,
          },
        ],
        4: [
          {
            name: 'Download,Open',
            ID: 0.2,
            IN: 0.2,
            PH: 0.23,
            US: 1.0,
            Other: 0.16,
            NG: 0.2,
            VN: 0.23,
            TH: 0.23,
            BR: 0.23,
            MX: 0.3,
            MY: 0.35,
            BD: 0,
            PK: 0,
          },
          {
            name: 'Rating',
            ID: 0.25,
            IN: 0.25,
            PH: 0.25,
            US: 0.5,
            Other: 0.1,
            NG: 0.25,
            VN: 0.25,
            TH: 0.25,
            BR: 0.27,
            MX: 0.25,
            MY: 0.25,
            BD: 0,
            PK: 0,
          },
          {
            name: 'Review',
            ID: 0.05,
            IN: 0.05,
            PH: 0.05,
            US: 0.5,
            Other: 0,
            NG: 0.05,
            VN: 0.05,
            TH: 0.05,
            BR: 0.05,
            MX: 0.05,
            MY: 0.1,
            BD: 0,
            PK: 0,
          },
        ],
        5: [
          {
            name: 'Likes to Review',
            ID: 0.1,
            IN: 0.1,
            PH: 0.1,
            US: 0.5,
            Other: 0,
            NG: 0.1,
            VN: 0.1,
            TH: 0.1,
            BR: 0.1,
            MX: 0.1,
            MY: 0.1,
            BD: 0.1,
            PK: 0.1,
          },
        ],
        7: [
          {
            name: 'Download,Open',
            ID: 0.2,
            IN: 0.2,
            PH: 0.23,
            US: 1.0,
            Other: 0.16,
            NG: 0.2,
            VN: 0.23,
            TH: 0.23,
            BR: 0.23,
            MX: 0.3,
            MY: 0.35,
            BD: 0.23,
            PK: 0.23,
          },
          {
            name: 'Rating',
            ID: 0.25,
            IN: 0.25,
            PH: 0.25,
            US: 0.5,
            Other: 0.1,
            NG: 0.25,
            VN: 0.25,
            TH: 0.25,
            BR: 0.27,
            MX: 0.25,
            MY: 0.25,
            BD: 0.25,
            PK: 0.25,
          },
          {
            name: 'Custom Review',
            ID: 0.1,
            IN: 0.1,
            PH: 0.1,
            US: 0.5,
            Other: 0.14,
            NG: 0.1,
            VN: 0.1,
            TH: 0.1,
            BR: 0.1,
            MX: 0.1,
            MY: 0.12,
            BD: 0.1,
            PK: 0.1,
          },
        ],
        8: [
          {
            name: 'Instagram Follow',
            ID: 0.04,
            IN: 0.04,
            PH: 0.04,
            Other: 0.04,
            NG: 0.04,
            VN: 0.04,
            TH: 0.04,
            BR: 0.04,
            MX: 0.04,
            MY: 0.04,
            BD: 0.04,
            PK: 0.04,
          },
        ],
        9: [
          {
            name: 'Instagram Post Like',
            ID: 0.04,
            IN: 0.04,
            PH: 0.04,
            Other: 0.04,
            NG: 0.04,
            VN: 0.04,
            TH: 0.04,
            BR: 0.04,
            MX: 0.04,
            MY: 0.04,
            BD: 0.04,
            PK: 0.04,
          },
        ],
        10: [
          {
            name: 'Youtube Subscribe',
            ID: 0.07,
            IN: 0.07,
            PH: 0.07,
            Other: 0.07,
            NG: 0.07,
            VN: 0.07,
            TH: 0.07,
            BR: 0.07,
            MX: 0.07,
            MY: 0.07,
            BD: 0.07,
            PK: 0.07,
          },
        ],
        11: [
          {
            name: 'Youtube Comment',
            ID: 0.12,
            IN: 0.12,
            PH: 0.12,
            Other: 0.12,
            NG: 0.12,
            VN: 0.12,
            TH: 0.12,
            BR: 0.12,
            MX: 0.12,
            MY: 0.12,
            BD: 0.12,
            PK: 0.12,
          },
        ],
      },
      typePrice: {
        1: [
          {
            name: 'Download,Open',
            ID: 0.2,
            IN: 0.23,
            PH: 0.2,
            US: 1.0,
            Other: 0.16,
            NG: 0.2,
            VN: 0.23,
            TH: 0.23,
            BR: 0.23,
            MX: 0.3,
            MY: 0.35,
            BD: 0.23,
            PK: 0.23,
          },
        ],
        2: [
          {
            name: 'Search Keyword,Install and Open',
            ID: 0.23,
            IN: 0.25,
            PH: 0.23,
            US: 1.2,
            Other: 0.18,
            NG: 0.23,
            VN: 0.25,
            TH: 0.25,
            BR: 0.26,
            MX: 0.32,
            MY: 0.38,
            BD: 0.25,
            PK: 0.25,
          },
        ],
        3: [
          {
            name: 'Download,Open',
            ID: 0.2,
            IN: 0.23,
            PH: 0.2,
            US: 1.0,
            Other: 0.16,
            NG: 0.2,
            VN: 0.23,
            TH: 0.23,
            BR: 0.23,
            MX: 0.3,
            MY: 0.35,
            BD: 0.23,
            PK: 0.23,
          },
          {
            name: 'Rating',
            ID: 0.08,
            IN: 0.08,
            PH: 0.08,
            US: 0.5,
            Other: 0.1,
            NG: 0.08,
            VN: 0.25,
            TH: 0.25,
            BR: 0.27,
            MX: 0.25,
            MY: 0.25,
            BD: 0.25,
            PK: 0.25,
          },
        ],
        4: [
          {
            name: 'Download,Open',
            ID: 0.2,
            IN: 0.23,
            PH: 0.2,
            US: 1.0,
            Other: 0.16,
            NG: 0.2,
            VN: 0.23,
            TH: 0.23,
            BR: 0.23,
            MX: 0.3,
            MY: 0.35,
            BD: 0,
            PK: 0,
          },
          {
            name: 'Rating',
            ID: 0.08,
            IN: 0.08,
            PH: 0.08,
            US: 0.5,
            Other: 0.1,
            NG: 0.08,
            VN: 0.25,
            TH: 0.25,
            BR: 0.27,
            MX: 0.25,
            MY: 0.25,
            BD: 0,
            PK: 0,
          },
          {
            name: 'Review',
            ID: 0.1,
            IN: 0.1,
            PH: 0.1,
            US: 0.5,
            Other: 0,
            NG: 0.1,
            VN: 0.05,
            TH: 0.05,
            BR: 0.05,
            MX: 0.05,
            MY: 0.1,
            BD: 0,
            PK: 0,
          },
        ],
        5: [
          {
            name: 'Likes to Review',
            ID: 0.1,
            IN: 0.1,
            PH: 0.1,
            US: 0.5,
            Other: 0,
            NG: 0.1,
            VN: 0.1,
            TH: 0.1,
            BR: 0.1,
            MX: 0.1,
            MY: 0.1,
            BD: 0.1,
            PK: 0.1,
          },
        ],
        7: [
          {
            name: 'Download,Open',
            ID: 0.2,
            IN: 0.23,
            PH: 0.2,
            US: 1.0,
            Other: 0.16,
            NG: 0.2,
            VN: 0.23,
            TH: 0.23,
            BR: 0.23,
            MX: 0.3,
            MY: 0.35,
            BD: 0.23,
            PK: 0.23,
          },
          {
            name: 'Rating',
            ID: 0.08,
            IN: 0.08,
            PH: 0.08,
            US: 0.5,
            Other: 0.1,
            NG: 0.08,
            VN: 0.25,
            TH: 0.25,
            BR: 0.27,
            MX: 0.25,
            MY: 0.25,
            BD: 0.25,
            PK: 0.25,
          },
          {
            name: 'Custom Review',
            ID: 0.2,
            IN: 0.2,
            PH: 0.2,
            US: 0.5,
            Other: 0.14,
            NG: 0.2,
            VN: 0.1,
            TH: 0.1,
            BR: 0.1,
            MX: 0.1,
            MY: 0.12,
            BD: 0.1,
            PK: 0.1,
          },
        ],
        8: [
          {
            name: 'Instagram Follow',
            ID: 0.04,
            IN: 0.04,
            PH: 0.04,
            Other: 0.04,
            NG: 0.04,
            VN: 0.04,
            TH: 0.04,
            BR: 0.04,
            MX: 0.04,
            MY: 0.04,
            BD: 0.04,
            PK: 0.04,
          },
        ],
        9: [
          {
            name: 'Instagram Post Like',
            ID: 0.04,
            IN: 0.04,
            PH: 0.04,
            Other: 0.04,
            NG: 0.04,
            VN: 0.04,
            TH: 0.04,
            BR: 0.04,
            MX: 0.04,
            MY: 0.04,
            BD: 0.04,
            PK: 0.04,
          },
        ],
        10: [
          {
            name: 'Youtube Subscribe',
            ID: 0.07,
            IN: 0.07,
            PH: 0.07,
            Other: 0.07,
            NG: 0.07,
            VN: 0.07,
            TH: 0.07,
            BR: 0.07,
            MX: 0.07,
            MY: 0.07,
            BD: 0.07,
            PK: 0.07,
          },
        ],
        11: [
          {
            name: 'Youtube Comment',
            ID: 0.12,
            IN: 0.12,
            PH: 0.12,
            Other: 0.12,
            NG: 0.12,
            VN: 0.12,
            TH: 0.12,
            BR: 0.12,
            MX: 0.12,
            MY: 0.12,
            BD: 0.12,
            PK: 0.12,
          },
        ],
      },
      typeComboPrice: {
        1: [
          {
            name: 'Download,Open',
            ID: 0.2,
            IN: 0.23,
            PH: 0.2,
            US: 1.0,
            Other: 0.16,
            NG: 0.2,
            VN: 0.23,
            TH: 0.23,
            BR: 0.23,
            MX: 0.3,
            MY: 0.35,
            BD: 0.23,
            PK: 0.23,
          },
        ],
        3: [
          {
            name: 'Rating',
            ID: 0.08,
            IN: 0.08,
            PH: 0.08,
            US: 0.5,
            Other: 0.1,
            NG: 0.08,
            VN: 0.25,
            TH: 0.25,
            BR: 0.27,
            MX: 0.25,
            MY: 0.25,
            BD: 0.25,
            PK: 0.25,
          },
        ],
        7: [
          {
            name: 'Custom Review',
            ID: 0.2,
            IN: 0.2,
            PH: 0.2,
            US: 0.5,
            Other: 0.14,
            NG: 0.2,
            VN: 0.1,
            TH: 0.1,
            BR: 0.1,
            MX: 0.1,
            MY: 0.12,
            BD: 0.1,
            PK: 0.1,
          },
        ],
      },
      typeComboNewPrice: {
        1: [
          {
            name: 'Download,Open',
            ID: 0.2,
            IN: 0.2,
            PH: 0.23,
            US: 1.0,
            Other: 0.16,
            NG: 0.2,
            VN: 0.23,
            TH: 0.23,
            BR: 0.23,
            MX: 0.3,
            MY: 0.35,
            BD: 0.23,
            PK: 0.23,
          },
        ],
        3: [
          {
            name: 'Rating',
            ID: 0.25,
            IN: 0.25,
            PH: 0.25,
            US: 0.5,
            Other: 0.1,
            NG: 0.25,
            VN: 0.25,
            TH: 0.25,
            BR: 0.27,
            MX: 0.25,
            MY: 0.25,
            BD: 0.25,
            PK: 0.25,
          },
        ],
        7: [
          {
            name: 'Custom Review',
            ID: 0.1,
            IN: 0.1,
            PH: 0.1,
            US: 0.5,
            Other: 0.14,
            NG: 0.1,
            VN: 0.1,
            TH: 0.1,
            BR: 0.1,
            MX: 0.1,
            MY: 0.12,
            BD: 0.1,
            PK: 0.1,
          },
        ],
      },
      typeComboDiscountPrice: {
        1: [
          {
            name: 'Download,Open',
            ID: 0.2,
            IN: 0.2,
            PH: 0.23,
            US: 1.0,
            Other: 0.16,
            NG: 0.2,
            VN: 0.23,
            TH: 0.23,
            BR: 0.23,
            MX: 0.3,
            MY: 0.35,
            BD: 0.23,
            PK: 0.23,
          },
        ],
        3: [
          {
            name: 'Rating',
            ID: 0.45,
            IN: 0.45,
            PH: 0.48,
            US: 0.5,
            Other: 0.1,
            NG: 0.45,
            VN: 0.48,
            TH: 0.48,
            BR: 0.5,
            MX: 0.55,
            MY: 0.6,
            BD: 0.25,
            PK: 0.25,
          },
        ],
        7: [
          {
            name: 'Custom Review',
            ID: 0.55,
            IN: 0.55,
            PH: 0.58,
            US: 0.5,
            Other: 0.14,
            NG: 0.55,
            VN: 0.58,
            TH: 0.58,
            BR: 0.6,
            MX: 0.65,
            MY: 0.72,
            BD: 0.1,
            PK: 0.1,
          },
        ],
      },
      orderPriceNewRule: [
        {
          // 1.Direct Install / Download,Open
          ID: 20,
          IN: 20,
          PH: 23,
          US: 100,
          Other: 16,
          NG: 20,
          VN: 23,
          TH: 23,
          BR: 23,
          MX: 30,
          MY: 35,
          BD: 23,
          PK: 23,
        },
        {
          // 2.Keyword Install / Search Keyword, Install and Open
          ID: 23,
          IN: 23,
          PH: 25,
          US: 120,
          Other: 18,
          NG: 23,
          VN: 25,
          TH: 25,
          BR: 26,
          MX: 32,
          MY: 38,
          BD: 25,
          PK: 25,
        },
        {
          // 3.Ratings / Install,open and rate
          ID: 45,
          IN: 45,
          PH: 48,
          US: 150,
          GB: 140,
          AU: 140,
          CA: 140,
          NZ: 130,
          IE: 130,
          SG: 130,
          ZA: 80,
          KE: 60,
          GH: 60,
          Other: 26,
          NG: 45,
          VN: 48,
          TH: 48,
          BR: 50,
          MX: 55,
          MY: 60,
          BD: 48,
          PK: 48,
        },
        {
          // 4.Reviews / Install,open,rate and Review
          ID: 50,
          IN: 50,
          PH: 53,
          US: 200,
          Other: 0,
          NG: 50,
          VN: 53,
          TH: 53,
          BR: 55,
          MX: 60,
          MY: 70,
          BD: 0,
          PK: 0,
        },
        {
          // 5.Likes to Review，已经删除？
          ID: 10,
          IN: 10,
          PH: 10,
          US: 50,
          Other: 0,
          NG: 10,
          VN: 10,
          TH: 10,
          BR: 10,
          MX: 10,
          MY: 10,
          BD: 10,
          PK: 10,
        },
        {},
        {
          // 7.Custom Reviews / Install,open,rate and Custom Review
          ID: 55,
          IN: 55,
          PH: 58,
          US: 200,
          GB: 180,
          AU: 180,
          CA: 180,
          NZ: 180,
          IE: 180,
          SG: 180,
          ZA: 100,
          KE: 80,
          GH: 80,
          Other: 40,
          NG: 55,
          VN: 58,
          TH: 58,
          BR: 60,
          MX: 65,
          MY: 72,
          BD: 58,
          PK: 58,
        },
        {
          // 8.Instagram Follow
          ID: 4,
          IN: 4,
          PH: 4,
          US: 4,
          Other: 4,
          NG: 4,
          VN: 4,
          TH: 4,
          BR: 4,
          MX: 4,
          MY: 4,
          BD: 4,
          PK: 4,
        },
        {
          // 9.Instagram Post Like
          ID: 4,
          IN: 4,
          PH: 4,
          US: 4,
          Other: 4,
          NG: 4,
          VN: 4,
          TH: 4,
          BR: 4,
          MX: 4,
          MY: 4,
          BD: 4,
          PK: 4,
        },
        {
          // 10.Youtube Subscribe
          ID: 7,
          IN: 7,
          PH: 7,
          US: 7,
          Other: 7,
          NG: 7,
          VN: 7,
          TH: 7,
          BR: 7,
          MX: 7,
          MY: 7,
          BD: 7,
          PK: 7,
        },
        {
          // 11.Youtube Comment
          ID: 12,
          IN: 12,
          PH: 12,
          US: 12,
          Other: 12,
          NG: 12,
          VN: 12,
          TH: 12,
          BR: 12,
          MX: 12,
          MY: 12,
          BD: 12,
          PK: 12,
        },
      ],
      orderPriceRule: [
        {
          // 1.Direct Install / Download,Open
          ID: 20,
          IN: 23,
          PH: 20,
          US: 100,
          Other: 16,
          NG: 20,
          VN: 23,
          TH: 23,
          BR: 23,
          MX: 30,
          MY: 35,
          BD: 23,
          PK: 23,
        },
        {
          // 2.Keyword Install / Search Keyword, Install and Open
          ID: 23,
          IN: 25,
          PH: 23,
          US: 120,
          Other: 18,
          NG: 23,
          VN: 25,
          TH: 25,
          BR: 26,
          MX: 32,
          MY: 38,
          BD: 25,
          PK: 25,
        },
        {
          // 3.Ratings / Install,open and rate
          ID: 28,
          IN: 31,
          PH: 28,
          US: 150,
          GB: 140,
          AU: 140,
          CA: 140,
          NZ: 130,
          IE: 130,
          SG: 130,
          ZA: 80,
          KE: 60,
          GH: 60,
          Other: 26,
          NG: 28,
          VN: 48,
          TH: 48,
          BR: 50,
          MX: 55,
          MY: 60,
          BD: 48,
          PK: 48,
        },
        {
          // 4.Reviews / Install,open,rate and Review
          ID: 38,
          IN: 41,
          PH: 38,
          US: 200,
          Other: 0,
          NG: 38,
          VN: 53,
          TH: 53,
          BR: 55,
          MX: 60,
          MY: 70,
          BD: 0,
          PK: 0,
        },
        {
          // 5.Likes to Review，已经删除？
          ID: 10,
          IN: 10,
          PH: 10,
          US: 10,
          Other: 0,
          NG: 10,
          VN: 10,
          TH: 10,
          BR: 10,
          MX: 10,
          MY: 10,
          BD: 10,
          PK: 10,
        },
        {},
        {
          // 7.Custom Reviews / Install,open,rate and Custom Review
          ID: 48,
          IN: 51,
          PH: 48,
          US: 200,
          GB: 180,
          AU: 180,
          CA: 180,
          NZ: 180,
          IE: 180,
          SG: 180,
          ZA: 100,
          KE: 80,
          GH: 80,
          Other: 40,
          NG: 48,
          VN: 58,
          TH: 58,
          BR: 60,
          MX: 65,
          MY: 72,
          BD: 58,
          PK: 58,
        },
        {
          // 8.Instagram Follow
          ID: 4,
          IN: 4,
          PH: 4,
          US: 4,
          Other: 4,
          NG: 4,
          VN: 4,
          TH: 4,
          BR: 4,
          MX: 4,
          MY: 4,
          BD: 4,
          PK: 4,
        },
        {
          // 9.Instagram Post Like
          ID: 4,
          IN: 4,
          PH: 4,
          US: 4,
          Other: 4,
          NG: 4,
          VN: 4,
          TH: 4,
          BR: 4,
          MX: 4,
          MY: 4,
          BD: 4,
          PK: 4,
        },
        {
          // 10.Youtube Subscribe
          ID: 7,
          IN: 7,
          PH: 7,
          US: 7,
          Other: 7,
          NG: 7,
          VN: 7,
          TH: 7,
          BR: 7,
          MX: 7,
          MY: 7,
          BD: 7,
          PK: 7,
        },
        {
          // 11.Youtube Comment
          ID: 12,
          IN: 12,
          PH: 12,
          US: 12,
          Other: 12,
          NG: 12,
          VN: 12,
          TH: 12,
          BR: 12,
          MX: 12,
          MY: 12,
          BD: 12,
          PK: 12,
        },
      ],
      comboRules: {
        cap1: [
          this.createRequiredRule(this, 'messages.tipError.emptyErr'),
          {
            validator: (rule, value, callback) => {
              if (!isInteger(value) || value < 10) {
                /* eslint-disable standard/no-callback-literal */
                callback(new Error(this.$t('messages.createCampaign.create127')))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
        cap2: [
          this.createRequiredRule(this, 'messages.tipError.emptyErr'),
          {
            validator: (rule, value, callback) => {
              let { cap1 } = this.combo
              if (!isInteger(value) || value < 5) {
                /* eslint-disable standard/no-callback-literal */
                callback(new Error(this.$t('messages.createCampaign.create126')))
              }
              if (cap1 && value > cap1) {
                /* eslint-disable standard/no-callback-literal */
                callback(new Error(this.$t('messages.createCampaign.create128')))
              }
              callback()
            },
            trigger: 'blur',
          },
        ],
      },
      keywordRules: [
        this.createRequiredRule(this, 'messages.tipError.emptyErr'),
        {
          validator: (rule, value, callback) => {
            let arr = rule.field.split('.')
            let index = 0
            if (arr.length > 1) {
              index = Number(arr[1])
            }
            // eslint-disable-next-line no-useless-escape
            let pattern = /[,，;；。.\、/]/
            if (
              (this.form.business_type === 2 || this.searchKeywordTypeSupport) &&
              pattern.test(value)
            ) {
              /* eslint-disable standard/no-callback-literal */
              callback(new Error(this.$t('messages.createCampaign.create131')))
              return
            }
            // if ((this.form.business_type === 2 || this.searchKeywordTypeSupport) && value.length > 20) {
            //   /* eslint-disable standard/no-callback-literal */
            //   callback('Each search keywords should not exceed 20 characters.')
            // }
            if (this.form.business_type === 4 && value.length > 180) {
              /* eslint-disable standard/no-callback-literal */
              callback(new Error(this.$t('messages.createCampaign.create129')))
            }
            let flag = this.form.info.some((row, i) => row.keyword === value && i !== index)
            if (flag) {
              /* eslint-disable standard/no-callback-literal */
              callback(new Error(this.$t('messages.createCampaign.create130')))
            }
            callback()
          },
          trigger: 'blur',
        },
      ],
      comboList: [
        {
          value: '',
          showErr: false,
          tip: 'Error',
        },
        {
          value: '',
          showErr: false,
          tip: 'Error',
        },
        {
          value: '',
          showErr: false,
          tip: 'Error',
        },
      ],
      reviewComboList: [
        {
          value: '',
          showErr: false,
          tip: 'Error',
        },
        {
          value: '',
          showErr: false,
          tip: 'Error',
        },
        {
          value: '',
          showErr: false,
          tip: 'Error',
        },
      ],
      reviewTypes: {
        list: {
          ref: 'reviewListRef',
          list: 'custom_review',
          allList: 'reviewList',
        },
        combo: {
          ref: 'comboListRef',
          list: 'comboList',
          allList: 'reviewComboList',
        },
        pop: {
          ref: 'reviewPopListRef',
          list: 'popList',
          allList: 'reviewPopList',
        },
      },
      aiVisible: false,
      generateXhr: null,
      mediaTypes: [8, 9, 10, 11],
      socialMediaTypes: [16, 17, 18, 19],
      newTypesValues: {
        8: ['Instagram Profile Link', 'Instagram Profile Username', 'Instagram Profile Avatar'], // Instagram Follow
        9: ['Instagram Post Link', 'Instagram Profile Username', 'Instagram Profile Avatar'], // Instagram Post Like
        10: ['Youtube Channel Link', 'Youtube Channel Name', 'Youtube Channel Avatar'], // Youtube Subscribe
        11: ['Youtube Video Link', 'Youtube Channel Name', 'Youtube Channel Avatar'], // Youtube Comment
      },
      newCountryPrice: {
        // 3:{// 3.Ratings / Install,open and rate
        //   US:1.50,GB:1.80,AU:1.40,CA:1.40,NZ:1.30,IE:1.30,SG:1.30,ZA:0.80,NG:0.60,KE:0.60,GH:0.60,
        //   BR:0.55,TH:0.48,VN:0.48,RU:0.90,MY:0.75,DE:1.80,MX:1.40,KR:1.40
        // },
        // 7:{// 7.Custom Reviews / Install,open,rate and Custom Review
        //   US:2.00,GB:1.80,AU:1.80,CA:1.80,NZ:1.70,IE:1.70,SG:1.70,ZA:1.00,NG:0.80,KE:0.80,GH:0.80,
        //   BR:0.65,TH:0.58,VN:0.58,RU:1.00,MY:0.80,DE:1.90,MX:1.80,KR:1.80
        // }
        3: {
          // 3.Ratings / Install,open and rate
          US: 1.5,
          GB: 1.8,
          AU: 1.4,
          CA: 1.4,
          NZ: 1.3,
          IE: 1.3,
          SG: 1.3,
          ZA: 0.8,
          NG: 0.45,
          KE: 0.6,
          GH: 0.6,
          BR: 0.5,
          TH: 0.48,
          VN: 0.48,
          RU: 0.9,
          MY: 0.6,
          DE: 1.8,
          MX: 0.55,
          KR: 1.4,
          BD: 0.48,
          PK: 0.48,
        },
        7: {
          // 7.Custom Reviews / Install,open,rate and Custom Review
          US: 2.0,
          GB: 1.8,
          AU: 1.8,
          CA: 1.8,
          NZ: 1.7,
          IE: 1.7,
          SG: 1.7,
          ZA: 1.0,
          NG: 0.55,
          KE: 0.8,
          GH: 0.8,
          BR: 0.6,
          TH: 0.58,
          VN: 0.58,
          RU: 1.0,
          MY: 0.72,
          DE: 1.9,
          MX: 0.65,
          KR: 1.8,
          BD: 0.58,
          PK: 0.58,
        },
      },
      typePrices: {}, // 类型价格
      typeComboPrices: {}, // combo类型的价格
      orderPriceRules: [], // 每种类型的单价
      imgsPopVisible: false,
      screenshots: [],
      popImg: '',
      popImgIndex: '',
      // 默认素材会作为 img 提交给远端，必须使用完整的 HTTPS 地址。
      defScreenshots: [
        `${IMAGE_CDN_ORIGIN}/creative/1792126622674c4e6593ce7458773104d045.png`,
        `${IMAGE_CDN_ORIGIN}/creative/17921265587b78ca6be5d4a020d330821269.png`,
        `${IMAGE_CDN_ORIGIN}/creative/17921266262e2ac567242ad04a1d398c4bd9.png`,
        `${IMAGE_CDN_ORIGIN}/creative/179212662933900ae618ff2046730877acc8.png`,
        `${IMAGE_CDN_ORIGIN}/creative/1792126632d7b654955862f81663c0dca360.png`,
      ],
      searchKeywordsType: [3, 7, 12, 13],
      searchKeywordTypePriceRule: {
        3: {
          ID: 48,
          IN: 48,
          PH: 50,
          US: 170,
          NG: 48,
          VN: 50,
          TH: 50,
          BR: 53,
          MX: 57,
          MY: 63,
        },
        7: {
          ID: 58,
          IN: 58,
          PH: 60,
          US: 220,
          NG: 58,
          VN: 60,
          TH: 60,
          BR: 63,
          MX: 67,
          MY: 75,
        },
      },
      bfTime: '2024-01-03 10:00:00',
      adsVisible: false,
      contacts: [
        {
          type: 1,
          iconD: 'skype_hui',
          icon: 'skype_lv',
        },
        {
          type: 2,
          iconD: 'whatsapp_hui',
          icon: 'whatsapp_lv',
        },
        {
          type: 3,
          iconD: 'telegram_hui',
          icon: 'telegram_lv',
        },
        {
          type: 4,
          iconD: 'wechat_hui',
          icon: 'wechat_lv',
        },
        {
          type: 5,
          iconD: 'kakaotalk_hui',
          icon: 'kakaotalk_lv',
        },
      ],
      contactType: 1,
      contactShowBtn: [1, 2, 3],
      contactShowCode: [4, 5],
      contactLinks: [
        'https://teams.live.com/l/invite/FEAOtIKX0rDmnGUuwE',
        'https://wa.me/+8618028539642',
        'https://t.me/youmiads',
      ],
      supportInfoVisible: false,
      typeData: [
        // business_type
        {
          id: 1,
          name: 'Direct Install',
          nameLangKey: 'create1',
          icon: 'direct-install',
          langKey: 'create113',
        },
        {
          id: 2,
          name: 'Keyword Install',
          nameLangKey: 'create2',
          icon: 'keyword-install',
          langKey: 'create114',
        },
        {
          id: 3,
          name: 'Ratings',
          nameLangKey: 'create123',
          icon: 'ratings',
          langKey: 'create115',
        },
        {
          id: 4,
          name: 'Reviews',
          nameLangKey: 'create124',
          icon: 'reviews',
          langKey: 'create116',
        },
        {
          id: 7,
          name: 'Custom Reviews',
          nameLangKey: 'create3',
          icon: 'custom-reviews',
          langKey: 'create117',
        },
        {
          id: 14,
          name: 'Guaranteed Review',
          nameLangKey: 'create4',
          icon: 'guaranteed-review',
          langKey: 'create118',
        },
        {
          id: 15,
          name: 'Likes&Dislikes',
          nameLangKey: 'create5',
          icon: 'real-likes',
          langKey: 'create119',
        },
      ],
      offlineTypeTips: {
        14: 'create120',
        15: 'create121',
      },
      offlineTypes: [14, 15],
      offlineTypesAll: [14, 15, 16, 17, 18, 19],
      offlineTypeCountry: ['ID', 'IN', 'PH', 'NG', 'MX', 'BR', 'VN', 'TH', 'MY'],
      offlineTypesPrice: {
        15: { ID: 0.1, IN: 0.1, NG: 0.1, PH: 0.1, MX: 0.1, BR: 0.1, VN: 0.1, TH: 0.1, MY: 0.1 },
        14: { ID: 1.5, IN: 1.5, NG: 1.5, PH: 1.6, MX: 1.7, BR: 1.6, VN: 1.6, TH: 1.6, MY: 3.0 },
        16: {
          ID: 0.06,
          IN: 0.06,
          NG: 0.06,
          PH: 0.06,
          MX: 0.06,
          BR: 0.06,
          VN: 0.06,
          TH: 0.06,
          MY: 0.7,
        },
        17: {
          ID: 0.06,
          IN: 0.06,
          NG: 0.06,
          PH: 0.06,
          MX: 0.06,
          BR: 0.06,
          VN: 0.06,
          TH: 0.06,
          MY: 0.7,
        },
        18: { ID: 0.3, IN: 0.3, NG: 0.3, PH: 0.3, MX: 0.67, BR: 0.3, VN: 0.3, TH: 0.3, MY: 0.7 },
        19: {
          ID: 0.55,
          IN: 0.55,
          NG: 0.55,
          PH: 0.58,
          MX: 0.67,
          BR: 0.75,
          VN: 0.58,
          TH: 0.58,
          MY: 0.7,
        },
      },
      // reviewsTypes: [7, 14],
      // reviewsTypesAndYtbComment: [7, 11, 14],
      reviewsTypes: [7],
      reviewsTypesAndYtbComment: [7, 11],
      oldCustomerTypes: [3, 4, 7, 14, 15],
      fiveTypes: [5, 15],
      freeTrial: true, // 是否开启新手试用switch
      keywordsInstall: false,
      previewVisible: false,
      selectOptionWidth: null,
      termsCheck: true,
      showTermErr: false,
      addAppVisible: false,
      applications: [],
      defaultImg: `${IMAGE_CDN_ORIGIN}/creative/17921266368f5fcf9568a6b5839e44d792c3.png`,
      rightNow: false,
      mode: 'create', // create, repeat, detail
      id: '',
      status: '',
      loading: false,
      createButtonLoading: false,
      payLaterButtonLoading: false,
      generateButtonLoading: false,
      form: {
        review_helpfulness_vote: '',
        app_store_url: '',
        package: '',
        app_name: '',
        icon: '',
        country: '', // ID
        tz: 7,
        schedule: [],
        start: '',
        end: '',
        // business_type: 1,
        business_type: 0,
        img: '', // Product Image
        post_banner: '', // Instagram Post Banner
        avatar: '',
        review_url: '',
        reviewer_name: '',
        review_screenshot: '',
        info: [
          {
            keyword: '',
            daily_cap: 10,
            total_cap: '',
            samplePictureFileList: [],
            hideSamplePictureUpload: false,
          },
        ],
        custom_review: '',
        cp_type: 1, // 0 single, 1 combo
        promotion_days: 1,
        developer_name: '',
        media_platform: 1,
        media_target: 1,
        comments_file: '',
        lang: '',
        user_category: '',
        product_feature: '',
        attitude: '',
      },
      // attitudeEN: 'Positive,Satisfied,Sincere,Enthusiastic,Praising',
      // attitudeCN: '积极,满意,真诚,热情,赞扬',
      mediaPlatformGM: 6,
      mediaPlatformYtb: 2,
      mediaTargetComment: 3,
      mediaTargetPostLike: 2,
      custom_review: [
        {
          value: '',
          showErr: false,
          tip: 'Error',
        },
      ],
      reviewList: [
        {
          value: '',
          showErr: false,
          tip: 'Error',
        },
      ],
      popList: [],
      reviewPopList: [],
      orderPriceCal: 0,
      orderPriceCal2: 0,
      packageDisabled: false,
      iconDisabled: false,
      appNameDisabled: false,
      campaignPrice: 0,
      packageShow: false,
      iconFileList: [],
      avatarFileList: [],
      hideIconUpload: false,
      hideAvatarUpload: false,
      hideProductImgUpload: false,
      hidePostBannerUpload: false,
      hideReviewScreenshotUpload: false,
      hideCommentUpload: false,
      commentFileList: [],
      imgFileList: [],
      bannerFileList: [],
      reviewScreenshotFileList: [],
      imgUrl: '',
      selectObj: {
        imgUrl: '',
        country: '',
        name: '',
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        },
      },
      countryOptions: this.initSelectOptions(countryAll),
      timezoneOptions: this.initSelectOptions(timezone),
      mediaOptionsList: this.initSelectOptions(mediaOptions),
      confirmVisible: false,
      balanceNotEnough: false,
      successVisible: false,
      failVisible: false,
      checkCampaign: {
        need: '',
        prices: '',
        balance: '',
        need_recharge: '',
      },
      asoGrowOption: {
        asogrow_media_platform: [],
        asogrow_media_target: [],
      },
      asoGrowOptionEN: {},
      errorOffset: 0,
      payListVisible: false,
      exportVisible: false,
      page: 1,
      total: 0,
      pageSize: 3,
      showPopErr: false,
      popErrTip: 'The document format is not supported.', // Invalid text content.
      popReview: '',
      cardIndex: 'card1',
      showCapErr: false,
      popType: '',
      // originalCountry:['ID','IN','PH'],
      originalCountry: ['ID', 'IN', 'PH', 'US', 'NG', 'TH', 'VN', 'BR', 'MX', 'MY', 'BD', 'PK'],
      BDAndPK: ['BD', 'PK'],
      originalNewCountry: [], // 'AU','NZ','IE','ZA','NG','KE','GH'
      asoh5Country: [], // AAN-8516
      // asoh5Country:['BR','TH','VN','RU'],// ,'MY','DE','GB','CA','MX','SG','KR','US',
      combo: {
        cap1: 100,
        cap2: 5,
      },
      importType: '',
      times: {
        ID: '7',
        IN: '5',
        PH: '8',
        BR: '-3',
        TH: '7',
        VN: '7',
        US: '-5',
        RU: '3',
        MY: '8',
        DE: '1',
        GB: '0',
        CA: '-5',
        MX: '-6',
        SG: '8',
        KR: '9',
        NG: '5',
        BD: '8',
        PK: '8',
      },
      newCounTypes: [3, 7, 14, 15], // 新国家支持的business type
    }
  },
  methods: {
    chooseMannerTag(tag) {
      let manner = this.form.attitude
      if (manner.split(',').includes(tag)) return
      if (manner === '') {
        manner = tag // 第一个字直接赋值
      } else {
        manner += ',' + tag // 后面加 , 拼接
      }
      this.$set(this.form, 'attitude', manner)
      // let manner = this.form.attitude + tag + ','
      console.log('chooseMannerTag', tag, manner)
    },
    syncAttitudeOnLocaleChange(oldLocale) {
      const fromTags = oldLocale === 'en' ? this.mannerTagsEN : this.mannerTagsCN
      const toTags = oldLocale === 'en' ? this.mannerTagsCN : this.mannerTagsEN
      const oldDefault = this.$i18n.messages[oldLocale].messages.other.attitude
      const current = (this.form.attitude || '').trim()

      if (!current || current === oldDefault) {
        this.$set(this.form, 'attitude', this.$t('messages.other.attitude'))
        return
      }

      const translated = current
        .split(',')
        .map(tag => {
          const trimmed = tag.trim()
          if (!trimmed) return ''
          const index = fromTags.indexOf(trimmed)
          return index !== -1 ? toTags[index] : trimmed
        })
        .filter(Boolean)
        .join(',')

      this.$set(this.form, 'attitude', translated)
    },
    refreshReviewListErrorsOnLocaleChange() {
      const updateTips = list => {
        if (!list || !list.some(item => item.showErr)) return
        const emptyTip = this.$t('messages.tipError.emptyErr2')
        const lenTip = this.$t('messages.tipError.limitErr3')
        const charTip = this.$t('messages.tipError.limitErr4')
        const repeatTip = this.$t('messages.other.other14')
        const duplicateIndexes = new Set(this.findDuplicateStrIndexes(list))

        list.forEach((item, index) => {
          if (!item.showErr) return
          const value = item.value == null ? '' : String(item.value).trim()
          if (!value) {
            item.tip = emptyTip
          } else if (value.length > 500) {
            item.tip = lenTip
          } else if (value.includes(';')) {
            item.tip = charTip
          } else if (duplicateIndexes.has(index)) {
            item.tip = repeatTip
          }
        })
      }

      updateTips(this.reviewList)
      updateTips(this.reviewComboList)
      updateTips(this.reviewPopList)
      if (this.importType) {
        this.handlePageList(this.importType)
      }
    },
    changeMediaPlatform(val) {
      if (val === 6) {
        this.$set(this.form, 'media_target', 3)
      } else if (this.commentTargetComputed || val === this.mediaPlatformYtb) {
        this.$set(this.form, 'media_target', 1)
      }
    },
    toContact() {
      let url = this.contactLinks[this.contactType - 1]
      window.open(url, '_blank')
    },
    chooseContactType(value, type) {
      if (this.contactType === type) return
      this.contactType = type
      this.$forceUpdate()
    },
    compareTime(uploadTime) {
      let flag = false
      if (this.mode === 'detail') {
        const date = new Date(this.form.ct).getTime()
        var timezone = 0 // 目标时区时间，东八区   东时区正数 西市区负数
        var offset_GMT = new Date(uploadTime).getTimezoneOffset() // 本地时间和格林威治的时间差，单位为分钟
        var nowDate = new Date(uploadTime).getTime() // 本地时间距 1970 年 1 月 1 日午夜（GMT 时间）之间的毫秒数
        var targetDate = new Date(nowDate + offset_GMT * 60 * 1000 + timezone * 60 * 60 * 1000)
        if (date < targetDate) {
          return true
        } else {
          return false
        }
      }
      return flag
    },
    getPriceOrTip(unit_price, discount_price) {
      let { discount, discount_type, ratio, ratioRate } = this.discounts
      if (discount_price) {
        let str = ''
        if (discount === 0 && discount_type === 0) {
          str = `$${this[unit_price]}`
        } else {
          str = `$${this[unit_price]} * ${ratio}% = $${this[discount_price]}`
        }
        return str
      } else {
        if (discount === 0 && discount_type === 0) {
          return this[unit_price]
        } else {
          return funCalc([this[unit_price], ratioRate], 2)
        }
      }
    },
    handleReviews(arr = []) {
      let allList = this.isCombo ? 'reviewComboList' : 'reviewList'
      if (arr.length > 0) {
        this[allList] = normalizeReviewRows(
          arr.map((row, i) => {
            return {
              value: row,
              showErr: false,
              tip: 'Error',
            }
          })
        )
      } else {
        this[allList] = [
          {
            value: '',
            showErr: false,
            tip: 'Error',
          },
        ]
      }

      this.$nextTick(() => {
        this.handlePageList(this.isCombo ? 'combo' : 'list')
      })
    },
    getRepeatRivews() {
      const campaignId = this.id
      const reviews = this.reviewList
      const originalReviews = JSON.stringify(reviews.map(row => row.value))
      return this.$http
        .get(`/api/campaign/${campaignId}/unconsumed_custom_review/`)
        .then(data => {
          // 用户编辑或导入后，复制来源的迟到回包不得覆盖当前文案。
          if (
            this.id !== campaignId ||
            this.mode !== 'repeat' ||
            this.reviewList !== reviews ||
            JSON.stringify(this.reviewList.map(row => row.value)) !== originalReviews
          ) {
            return
          }
          this.handleReviews(data.data.custom_review)
          this.changeReviewCap(this.form.info[0])
        })
        .catch(error => {
          this.notifyOpen('Error', this.executeError(error), 'error')
        })
    },
    setRealBT() {
      let business_type = this.form.business_type
      if (this.searchKeywordTypeSupport) {
        if (this.form.business_type === 3) {
          business_type = 12
        } else {
          business_type = 13
        }
      } else if (this.socialMediaTypeComputed) {
        business_type = this.realBusinessType
      }
      return business_type
    },
    openUpload() {
      // this.imgFileList = []
      // this.$refs.upload.clearFiles()
      this.$refs.upload.$refs['upload-inner'].handleClick()
    },
    changeChoose(url, i) {
      this.popImg = url
      this.popImgIndex = i
    },
    confirmChoose() {
      this.imgsPopVisible = false
      // if(this.popImg){
      //   this.setImg(this.popImg)
      // }
      if (this.popImgIndex !== '') {
        this.setImg(this.screenshots[this.popImgIndex])
      }
    },
    showImgsPop() {
      this.imgsPopVisible = true
    },
    chooseBusiness(type) {
      this.$set(this.form, 'business_type', type)
      this.$nextTick(() => {
        this.$refs.createCampaign.validateField('country', () => {})
      })
    },
    getNewTypeValue(val) {
      let type = this.form.business_type
      return this.newTypesValues[type][val]
    },
    handleSelectionChange(arr) {
      this.selectedReviews = arr
    },
    clearData() {
      this.aiFeedback = {
        id: '',
        like: '',
        comment: '',
      }
      this.aiReviews = []
      this.selectedReviews = []
    },
    checkFeedBack: throttleFn(function(type) {
      if (this.aiFeedback.like !== '' || this.aiFeedback.comment !== '') {
        this.aiFeedback.like = Number(this.aiFeedback.like)
        this.$http
          .post('/api/campaign/gpt_reviews/feedback/', this.aiFeedback)
          .then(data => {
            type === 2 ? this.handleComfirm('ai') : this.clearData()
          })
          .catch(error => {
            this.notifyOpen('Error', this.executeError(error), 'error')
          })
      } else {
        type === 2 ? this.handleComfirm('ai') : this.clearData()
      }
    }, 3000),
    handleReEdit() {
      this.checkFeedBack(1)
    },
    handleAIImport() {
      this.checkFeedBack(2)
    },
    changeCountryOption(index) {
      this.aiForm.app_id = this.applications[index].id
    },
    abortGenerateRequest(resetLoading = true) {
      if (this.generateXhr) {
        this.generateXhr.abort()
        this.generateXhr = null
      }
      if (resetLoading) {
        this.generateButtonLoading = false
      }
    },
    closeAiDialog() {
      this.abortGenerateRequest()
      this.aiVisible = false
    },
    handleAiDialogBeforeClose(done) {
      this.abortGenerateRequest()
      done()
    },
    handleAiDialogClose() {
      this.abortGenerateRequest()
    },
    handleGenerate() {
      this.$refs.aiReviewRef.validate(valid => {
        if (valid) {
          this.aiForm.name = this.form.app_name
          this.aiForm.package = this.form.package
          let arr = ['app_id', 'name', 'package', 'summary']
          let arr2 = ['video_summary']
          let params = omit(this.aiForm, arr2)
          let { business_type } = this.form
          if (business_type === 11) {
            params = omit(params, arr)
            params.summary = this.aiForm.video_summary
          }
          let obj = this.languageOptions.filter(row => row.id === this.aiForm.language)
          if (obj && obj[0]) {
            params.language = obj[0].name
          }
          this.abortGenerateRequest(false)
          const xhr = new XMLHttpRequest()
          this.generateXhr = xhr
          const body = Qs.stringify({ ...params, business_type }, { arrayFormat: 'repeat' })
          this.generateButtonLoading = true
          xhr.open('POST', '/api/campaign/gpt_reviews/create/')
          xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
          xhr.setRequestHeader('X-CSRFToken', getCookie('csrftoken'))
          xhr.onload = () => {
            if (this.generateXhr !== xhr) {
              return
            }
            this.generateXhr = null
            this.generateButtonLoading = false
            try {
              const data = JSON.parse(xhr.responseText)
              if (data.c === -1) {
                // let errTip = 'AI failed to generate long reviews. Please retry or reduce the number of reviews to lower failure rate.'
                let errTip = this.$t('messages.support.support36')
                this.notifyOpen('Error', errTip, 'error')
                return
              }
              if (data.c !== 0) {
                this.notifyOpen('Error', this.executeError(data), 'error')
                return
              }
              this.aiReviews = data.d.data.reviews
              this.aiFeedback.id = data.d.data.id
              this.$nextTick(() => {
                this.$refs.dataTable.toggleAllSelection()
              })
            } catch (error) {
              this.notifyOpen('Error', this.executeError(error), 'error')
            }
          }
          xhr.onerror = () => {
            if (this.generateXhr !== xhr) {
              return
            }
            this.generateXhr = null
            this.generateButtonLoading = false
            this.notifyOpen('Error', 'Network error', 'error')
          }
          xhr.onabort = () => {
            if (this.generateXhr !== xhr) {
              return
            }
            this.generateXhr = null
            this.generateButtonLoading = false
          }
          xhr.send(body)
        }
      })
    },
    handleFeedBack(val = '') {
      this.$set(this.aiFeedback, 'like', val)
    },
    openGenerated(type) {
      this.abortGenerateRequest()
      let flag = this.languageOptions.some(row => row.id === this.form.country)
      let language = 'US'
      if (flag) {
        language = this.form.country
      }
      this.$set(this.aiForm, 'language', language)
      this.aiVisible = true
      this.importType = type
    },
    setOptionWidth(event) {
      this.$nextTick(() => {
        this.selectOptionWidth = event.srcElement.offsetWidth + 'px'
      })
    },
    changeCap1() {
      this.$refs.comboCampaign.validateField('cap2', (valid, error) => {})
    },
    getAppListParams() {
      return {}
    },
    getAppList(action) {
      // this.loading = true
      this.$http
        .get('/api/applications/', {
          params: this.getAppListParams(),
        })
        .then(res => {
          // this.loading = false
          if (res.data.applications) {
            this.applications = res.data.applications
            let paramUrl = action === 'repeat' ? this.form.app_store_url : this.$route.query.url
            if (paramUrl) {
              let arr = []
              arr = this.applications.filter(i => i.app_store_url === paramUrl)
              if (arr.length > 0) {
                let obj = arr[0]
                this.aiForm.app_id = obj.id
                this.selectObj.imgUrl = obj.icon_url
                this.selectObj.country = obj.country
                this.selectObj.name = obj.app_name
                this.form.icon = obj.icon_url
                this.form.country = obj.country
                this.form.app_name = obj.app_name
                this.form.app_store_url = obj.app_store_url
                this.form.package = obj.package
                this.initOneImage(obj.icon_url, 'iconFileList')
              }
            }
            if (action === 'change') {
              let obj = this.applications[0]
              this.aiForm.app_id = obj.id
              this.selectObj.imgUrl = obj.icon_url
              this.selectObj.country = obj.country
              this.selectObj.name = obj.name || obj.app_name
              this.form.country = obj.country
              this.form.icon = obj.icon_url
              this.form.app_name = obj.name || obj.app_name
              this.form.app_store_url = obj.app_store_url
              this.form.package = obj.package
              this.initOneImage(obj.icon_url, 'iconFileList')
            }
          }
        })
        .catch(() => {
          // this.loading = false
        })
    },
    getNewUrl(value) {
      let country = this.form.country
      let str = ''
      if (this.getUrlParam('gl', value) && this.getUrlParam('hl', value)) {
        return value
      }
      if (country === 'ID') {
        str = '&gl=id&hl=id'
      }
      if (country === 'IN') {
        str = '&gl=in&hl=en'
      }
      if (country === 'PH') {
        str = '&gl=ph&hl=en'
      }
      if (country === 'US') {
        str = '&gl=us&hl=en'
      }
      if (country === 'NG') {
        str = '&gl=ng&hl=en'
      }
      if (country === 'VN') {
        str = '&gl=vn&hl=en'
      }
      if (country === 'TH') {
        str = '&gl=th&hl=en'
      }
      if (country === 'BR') {
        str = '&gl=br&hl=en'
      }
      if (country === 'MX') {
        str = '&gl=mx&hl=en'
      }
      if (country === 'MY') {
        str = '&gl=my&hl=en'
      }
      if (country === 'BD') {
        str = '&gl=bd&hl=en'
      }
      if (country === 'PK') {
        str = '&gl=pk&hl=en'
      }
      return value + str
    },
    handleDownload() {
      let datalist = [] // 导出表格表头
      datalist.push(['keywords'])
      this.downloadXlsx(datalist, 'Reviews.xlsx')
    },
    clearPopStatus() {
      this.clearPopStatus()
      this.popList = []
      this.reviewPopList = []
      this.cardIndex = 'card1'
      this.popReview = ''
      if (this.$refs.reviewPopListRef) {
        this.$refs.reviewPopListRef.page2 = 1
      }
    },
    handleNewArr(arr) {
      let newArr = arr.map(item => {
        let obj = {
          value: item,
          tip: 'Error',
          showErr: false,
        }
        return obj
      })
      return newArr
    },
    handleComfirm(action) {
      let typeObj = this.reviewTypes[this.importType]
      let allList = typeObj.allList
      let str =
        this.importType === 'list'
          ? this.$t('messages.createCampaign.create64')
          : this.$t('messages.createCampaign.create146')
      let msg = `${str} ${this.$t('messages.createCampaign.create146')}` // eslint-disable-line
      if (action !== 'ai') {
        if (this.cardIndex === 'card1') {
          if (this.reviewPopList.length === 0) {
            this.$message({ type: 'warning', message: msg, duration: 3000 })
            return
          }
          this[allList] = [...this[allList], ...this.reviewPopList]
        } else {
          let arr = this.popReview.split(/[.;]/)
          let newArr = arr.filter(i => i !== '')
          if (newArr.length === 0) {
            this.$message({ type: 'warning', message: msg, duration: 3000 })
            return
          }
          this[allList] = [...this[allList], ...this.handleNewArr(newArr)]
        }
      } else {
        let reviewArr = this.selectedReviews.map(item => {
          let obj = {
            value: item,
            tip: 'Error',
            showErr: false,
          }
          return obj
        })
        let newList = [...this[allList], ...reviewArr]
        this[allList] = newList.filter(item => item.value !== '')
      }
      this[allList] = normalizeReviewRows(this[allList])

      if (this.importType === 'list') {
        this.changeReviewCap(this.form.info[0])
        if (action !== 'ai') {
          this.$refs.reviewListRef[0].page = 1
        }
      } else {
        if (action !== 'ai') {
          this.$refs.comboListRef.page3 = 1
        }
      }
      this.exportVisible = false
      if (action === 'ai') {
        this.aiVisible = false
        this.clearData()
      }
      this.handlePageList(this.importType)
    },
    handlePageList(type) {
      let page = 1
      let pageSize = 10
      if (type === 'pop') {
        if (this.$refs.reviewPopListRef) {
          page = this.$refs.reviewPopListRef.page2
          pageSize = this.$refs.reviewPopListRef.pageSize
        }
        this.popList = this.reviewPopList.slice((page - 1) * pageSize, page * pageSize)
      } else if (type === 'combo') {
        if (this.$refs.comboListRef) {
          page = this.$refs.comboListRef.page3
          pageSize = this.$refs.comboListRef.pageSize
        }
        this.comboList = this.reviewComboList.slice((page - 1) * pageSize, page * pageSize)
      } else if (type === 'list') {
        if (this.$refs.reviewListRef) {
          page = this.$refs.reviewListRef[0].page
          pageSize = this.$refs.reviewListRef[0].pageSize
        }
        this.custom_review = this.reviewList.slice((page - 1) * pageSize, page * pageSize)
      }
    },
    handleDeleteAll() {
      let obj = {
        value: '',
        showErr: false,
        tip: 'Error',
      }
      this.reviewList = [obj]
      this.custom_review = [obj]
      this.$refs.reviewListRef[0].page = 1
      this.changeReviewCap(this.form.info[0])
    },
    handleReviewAdd(i, type, popType) {
      let typeObj = this.reviewTypes[popType]
      let ref = this.$refs[typeObj.ref]
      let list = typeObj.list
      let allList = typeObj.allList
      if (type === 1 && popType === 'combo' && this[allList].length === 1) {
        return
      }
      if (ref) {
        let str = popType === 'list' ? 'custom reviews' : 'good reviews'
        let revNum = 3000
        if (this.freeTrialUse) {
          revNum = 5
        }
        if (type === 0 && this[allList].length >= revNum) {
          // this.$message.error(`The number of ${str} cannot exceed ${revNum}!`)
          let ert = `${this.$t('messages.other.other50')}${str} ${this.$t(
            'messages.other.other51'
          )}} ${revNum}!`
          this.$message.error(ert)
          return
        }
        let page, pageSize
        if (popType === 'list') {
          page = this.$refs.reviewListRef[0].page
          pageSize = this.$refs.reviewListRef[0].pageSize
        } else if (popType === 'pop') {
          page = this.$refs.reviewPopListRef.page2
          pageSize = this.$refs.reviewPopListRef.pageSize
        } else if (popType === 'combo') {
          page = this.$refs.comboListRef.page3
          pageSize = this.$refs.comboListRef.pageSize
        }
        if (type === 1) {
          this[list].splice(i, 1)
          this[allList].splice(i + (page - 1) * pageSize, 1)
        } else {
          let obj = {
            value: '',
            showErr: false,
            tip: 'Error',
          }
          if (popType === 'combo') {
            this[list].push(obj)
            this[allList].push(obj)
          } else {
            this[list].unshift(obj)
            this[allList].unshift(obj)
          }
        }
        if (this.popList.length === 0 && popType === 'pop') {
          this.$refs.reviewPopListRef.page2 = page - 1
        }
        if (popType === 'list') {
          this.changeReviewCap(this.form.info[0])
          if (this.custom_review.length === 0) {
            this.$refs.reviewListRef[0].page = page - 1
          }
        }
        if (popType === 'combo' && this[list].length === 0) {
          this.$refs.comboListRef.page3 = page - 1
        }
        this.handlePageList(popType)
      }
    },
    getTimeZ(tz) {
      let str = ''
      this.timezoneOptions.map(i => {
        if (Number(i.id) === Number(tz)) {
          str = i.name
        }
        return i
      })
      return str
    },
    initPage() {
      this.getProfile()
      this.getOptions()
      this.screenshots = [...this.defScreenshots]
      if (this.$route.query.type === 'repeat') {
        this.id = this.$route.query.id
        this.mode = 'repeat'
      }
      if (this.$route.query.type === 'detail') {
        this.id = this.$route.query.id
        this.mode = 'detail'
      }
      if (this.mode === 'create') {
        this.$set(this.form, 'attitude', this.$t('messages.other.attitude'))
      }
      if ((this.mode === 'repeat' || this.mode === 'detail') && this.id) {
        this.getCampaignDetail()
      } else {
        let obj = this.form.info[0]
        this.changeDailyCap(obj.daily_cap, obj)
        this.getAppList()
      }
    },
    getTotal(single) {
      let total = 0
      total = (single * this.sumTotalCap).toFixed(2)
      return total
    },
    getTotalCombo(single, type) {
      let total = 0
      if (type === 1) {
        total = (single * this.totCap1).toFixed(2)
      }
      if (type === 2) {
        total = (single * this.totCap2).toFixed(2)
      }
      if (type === 3) {
        total = (single * this.reviewLen).toFixed(2)
      }
      return total
    },
    showPay(e, type) {
      this.payListVisible = true
      this.popType = type
      if (type === 1) {
        e.preventDefault()
      }
    },
    unCollectComData(data) {
      data.map((row, i) => {
        if (row.business_type === 1) {
          this.combo.cap1 = row.daily_cap
        }
        if (row.business_type === 3) {
          this.combo.cap2 = row.daily_cap
        }
      })
    },
    collectComData() {
      let { cap1, cap2 } = this.combo
      let len = this.reviewLen
      let list = []
      for (let i = 0; i < 3; i++) {
        let obj = {
          total_cap: '',
          business_type: '',
          sample_picture: '',
          keyword: '',
          daily_cap: '',
        }
        if (i === 0) {
          obj.daily_cap = cap1
          obj.total_cap = cap1 * this.scheduleDays
          obj.business_type = 1
        }
        if (i === 1) {
          obj.daily_cap = cap2
          obj.total_cap = cap2 * this.scheduleDays
          obj.business_type = 3
        }
        if (i === 2) {
          obj.daily_cap = Math.ceil(len / this.scheduleDays)
          obj.total_cap = len
          obj.business_type = 7
        }
        list.push(obj)
      }
      return list
    },
    handleExportBackend(type) {
      if (!this.id) return
      const url = `/api/campaign/${this.id}/get_custom_review_csv/`
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    handleExportFront(type) {
      const rows = this.reviewList.map(row => row.value)
      const csvContent =
        '\uFEFF' + rows.map(item => `"${String(item).replace(/"/g, '""')}"`).join('\n')
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' })
      const downloadLink = document.createElement('a')
      downloadLink.href = URL.createObjectURL(blob)
      downloadLink.download = 'custom_review.csv'
      document.body.appendChild(downloadLink)
      downloadLink.click()
      document.body.removeChild(downloadLink)
    },
    handleExport(type) {
      if (this.mode === 'detail') {
        this.handleExportBackend(type)
      } else {
        this.handleExportFront(type)
      }
    },
    handleImport(type) {
      this.exportVisible = true
      this.importType = type
    },
    changeReviewCap(item) {
      // end time实际时间为23:59:59, 所以日期差值加1
      if (this.scheduleDays - 1 >= 0) {
        let total = normalizeReviewRows(this.reviewList).length
        item.total_cap = total
        item.daily_cap = Math.ceil(total / this.scheduleDays)
      }
      this.checkCap()
    },
    changeTermCheck(val) {
      if (val) {
        this.showTermErr = false
      }
    },
    businessTypeCheck(type) {
      // 禁用 likes to Review 和 Instagram Post Like
      if (type === 5 || type === 9) {
        return true
      }

      // 新手试用，Business Type仅支持Single Business - ASO类型任务
      let arr = [8, 9, 10, 11]
      if (this.freeTrialUse && arr.includes(type)) {
        return true
      }
      if (!this.form.country) {
        return false
      }

      if (this.otherCountry && (type === 4 || type === 5)) {
        return true
      }
      return false
    },
    countryDisabled(country) {
      let flag = this.originalCountry.indexOf(country) < 0
      if (this.freeTrialUse && flag) {
        return true
      } else {
        return false
      }
    },
    handleCB(arr) {
      this.addAppVisible = false
      this.getAppList('change')
      this.screenshots = [...(arr || []), ...this.defScreenshots]
      // this.popImg = this.screenshots[0]
      this.popImgIndex = 0
      this.setImg(this.screenshots[0])
    },
    showAddApp() {
      this.addAppVisible = true
    },
    getUrlParam(name, url) {
      var arr = url.split('?')
      var argStr = arr.length > 1 ? arr[1] : ''
      if (!argStr) {
        return null
      }
      var arr2 = argStr.split('&').map(item => item.split('='))
      var res = arr2.find(item => item[0] === name)
      if (res) {
        return res.length > 1 ? res[1] : null
      } else {
        return null
      }
    },
    getProfile() {
      if (this.$route.query.url) {
        this.form.app_store_url = this.$route.query.url
        this.$nextTick(() => {
          this.changeAppStoreUrl(this.form.app_store_url, 1)
        })
      }
      if (this.$route.query.country) {
        this.form.country = this.$route.query.country
      }
      if (this.$route.query.businessType) {
        this.form.business_type = Number(this.$route.query.businessType)
      }
      if (this.$route.query.dailyCap) {
        this.form.info[0].daily_cap = Number(this.$route.query.dailyCap)
      }
      this.$store.dispatch('getProfile', { action: 1 }).then(() => {})
    },
    setImg(imgUrl) {
      this.form.img = imgUrl
      this.initOneImage(this.form.img, 'imgFileList')
      this.hideProductImgUpload = this.imgFileList.length > 0
    },
    handleChangeCountry(type, val) {
      if (type === 2 && !this.form.app_store_url) {
        return
      }
      if (type === 2 && val) {
        this.$set(this.form, 'country', val)
        if (this.jdCountry || this.asoCountry) {
          let timezone = Number(this.times[val])
          this.$set(this.form, 'tz', timezone)
        }
      }
      this.changeAppStoreUrl(this.form.app_store_url, type)
    },
    getOptions() {
      this.$http
        .get('/api/data/settings/', {
          params: {
            fields: 'asogrow',
          },
        })
        .then(data => {
          this.asoGrowOptionEN = data.data.asogrow
          if (this.isEnglish) {
            this.asoGrowOption = data.data.asogrow
          }
        })
        .catch(err => {
          this.notifyOpen('Error', this.executeError(err), 'error')
        })
    },
    async getCampaignDetail() {
      await this.getCostDetail()
      this.loading = true
      this.$http
        .get(`/api/campaign/${this.id}/`)
        .then(data => {
          this.form = { ...this.form, ...data.data }
          if (data.data.cp_type === 1) {
            this.form.business_type = 0
          } else if (data.data.business_type === 12) {
            this.chooseBusiness(3)
            this.keywordsInstall = true
          } else if (data.data.business_type === 13) {
            this.chooseBusiness(7)
            this.keywordsInstall = true
          }
          let schedule = ['', '']
          if (this.form.start && this.form.end) {
            schedule = [this.form.start.substr(0, 10), this.form.end.substr(0, 10)]
          }
          this.$set(this.form, 'schedule', schedule)
          this.status = this.form.status
          this.packageShow = true
          this.initOneImage(this.form.icon, 'iconFileList')
          if (this.form.icon) {
            this.hideIconUpload = true
            this.selectObj.imgUrl = this.form.icon
          }
          this.initOneImage(this.form.img, 'imgFileList')
          if (this.form.img) {
            this.hideProductImgUpload = true
          }
          this.initOneImage(this.form.post_banner, 'bannerFileList')
          if (this.form.post_banner) {
            this.hidePostBannerUpload = true
          }
          this.initOneImage(this.form.avatar, 'avatarFileList')
          if (this.form.avatar) {
            this.hideAvatarUpload = true
          }
          this.initOneImage(this.form.review_screenshot, 'reviewScreenshotFileList')
          if (this.form.review_screenshot) {
            this.hideReviewScreenshotUpload = true
          }
          this.initCommentsFile(this.form.comments_file, 'commentFileList')
          // this.form.business_type === 7
          if (this.reviewsTypesComputed && this.mode === 'repeat') {
            this.getRepeatRivews()
          } else if (this.reviewsTypesAndYtbCommentComputed || this.isCombo) {
            let arr = data.data.custom_review.split(';')
            this.handleReviews(arr)
          } else {
            this.custom_review = [
              {
                value: '',
                showErr: false,
                tip: 'Error',
              },
            ]
          }
          if (this.isCombo) {
            this.info = [
              {
                keyword: '',
                daily_cap: 10,
                total_cap: '',
                sample_picture: '',
                samplePictureFileList: [],
                hideSamplePictureUpload: false,
              },
            ]
            this.unCollectComData(data.data.info)
          } else {
            this.form.info.forEach(item => {
              if (item.sample_picture) {
                item.samplePictureFileList = [{ url: item.sample_picture }]
                item.hideSamplePictureUpload = true
              }
            })
          }
          // 复制campaign时不能填过去时间，清空schedule
          if (this.mode === 'repeat') {
            this.form.schedule = []
            this.getAppList('repeat')
          } else {
            this.getAppList()
          }
          this.loading = false
          this.$nextTick(() => {
            this.changeAppStoreUrl(this.form.app_store_url, 3)
          })
        })
        .catch(error => {
          this.loading = false
          this.notifyOpen('Error', this.executeError(error), 'error')
        })
    },
    getCostDetail() {
      this.$http
        .get(`/api/campaign/${this.id}/cost_detail/`)
        .then(data => {
          this.costReportData = data.data
          this.costReportData.discount_type = data.data.discount_type
          this.use_total_price_discount = data.data.use_total_price_discount
        })
        .catch(err => {
          this.costReportLoading = false
          // this.notifyOpen('Error', this.executeError(err), 'error')
          console.log(err)
        })
    },
    getQueryString(name, url_string) {
      if (!url_string) {
        return false
      }
      var arr = url_string.split('?')
      var query
      if (arr.length > 1) {
        query = arr[1]
      }
      var vars = query.split('&')
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=')
        if (pair[0] === name) {
          return pair[1]
        }
      }
      return false
    },
    evil(fn) {
      let Fn = Function
      return new Fn('return ' + fn)()
    },
    changeURLArg(url, arg, arg_val) {
      var pattern = arg + '=([^&]*)'
      var replaceText = arg + '=' + arg_val
      if (url.match(pattern)) {
        var tmp = '/(' + arg + '=)([^&]*)/gi'
        tmp = url.replace(this.evil(tmp), replaceText)
        return tmp
      } else {
        if (url.match('[?]')) {
          // eslint-disable-line
          return url + '&' + replaceText
        } else {
          return url + '?' + replaceText
        }
      }
    },
    changeAppStoreUrl(value, type) {
      if (!value) {
        return
      }
      this.$refs.createCampaign.validateField('app_store_url', error => {
        if (!error) {
          let newUrl = value
          let gl = this.form.country.toLowerCase()
          let hl = ''
          if (type === 1) {
            let country = this.getQueryString('gl', newUrl)
            this.form.country = country.toUpperCase()
          } else {
            newUrl = this.changeURLArg(newUrl, 'gl', gl)
            if (gl === 'id') {
              hl = 'id'
            } else {
              hl = 'en'
            }
            newUrl = this.changeURLArg(newUrl, 'hl', hl)
            // this.form.app_store_url = newUrl
          }
          let params = {
            country: this.form.country,
            pre_info: newUrl,
            gl,
            hl,
            is_need_screenshot: 1,
          }
          this.$http
            .get('/api/applications/gpinfo/', { params })
            .then(res => {
              if (res.data.application) {
                const data = res.data.application
                if (type === 3) {
                  this.screenshots = [...data.screenshots, ...this.defScreenshots]
                } else {
                  let packageVal = this.getQueryString('id', newUrl)
                  if (packageVal) {
                    this.form.package = packageVal
                    this.packageDisabled = true
                  }
                  if (data.icon_url) {
                    this.form.icon = data.icon_url
                    this.iconFileList = [{ url: data.icon_url }]
                    this.iconDisabled = true
                    this.hideIconUpload = true
                  }
                  if (data.name) {
                    this.$set(this.form, 'app_name', data.name)
                    this.appNameDisabled = true
                  }
                  this.aiForm.summary = data.summary
                  this.screenshots = [...data.screenshots, ...this.defScreenshots]
                  // this.popImg = this.screenshots[0]
                  this.popImgIndex = 0
                  this.setImg(this.screenshots[0])
                  this.$forceUpdate()
                  this.packageShow = true
                }
                if (this.form.country === 'US') {
                  this.keywordsInstall = false
                }
                if (this.isGuaranteedReview) {
                  this.form.user_category = data.category
                  this.form.lang = data.country
                }
              } else {
                this.aiForm.summary = ''
              }
            })
            .catch(() => {
              // this.loading = false
            })
        }
      })
    },
    handleAvatarBefore(file) {
      const size = Math.ceil(file.size / 1024)
      const url = URL.createObjectURL(file)
      if (size <= 500) {
        const img = new Image()
        const promise = new Promise((resolve, reject) => {
          img.onload = () => {
            const { width, height } = img
            if (width === height) {
              resolve()
            } else {
              this.$message({
                type: 'error',
                message: this.$t('messages.createCampaign.create148'),
                duration: 3000,
              })
              /* eslint-disable prefer-promise-reject-errors */
              reject()
            }
          }
        })
        img.src = url
        return promise
      } else {
        this.$message({
          type: 'error',
          message: this.$t('messages.createCampaign.create137'),
          duration: 3000,
        })
        return false
      }
    },
    handleAvatarChange(file, filelist) {
      this.hideAvatarUpload = filelist.length > 0
    },
    handleAvatarSuccess(response, file, filelist) {
      if (response.c !== 0) {
        filelist.splice(filelist.length - 1, 1)
        this.notifyOpen('Error', response.m, 'error')
        return
      }
      this.avatarFileList = filelist
      this.form.avatar = response.d.s3_link
      this.avatarFileList[0].url = response.d.s3_link
    },
    handleAvatarRemove() {
      this.avatarFileList = []
      this.form.avatar = ''
      this.hideAvatarUpload = false
    },
    handleCommentSuccess(response, file, filelist) {
      if (response.c !== 0) {
        filelist.splice(filelist.length - 1, 1)
        this.notifyOpen('Error', response.m, 'error')
        return
      }
      this.commentFileList = filelist
      this.form.comments_file = response.d.s3_link
      this.commentFileList[0].url = response.d.s3_link
      console.log('commentFileList', this.commentFileList)
    },
    handleCommentBefore(file) {
      console.log('handleCommentBefore', file)
    },
    handleCommentRemove() {
      this.commentFileList = []
      this.form.comments_file = ''
      this.hideCommentUpload = false
    },
    handleCommentChange(file, filelist) {
      console.log('handleCommentChange', file, filelist)
    },
    handleProductImgBefore(file) {
      const size = Math.ceil(file.size / 1024)
      const url = URL.createObjectURL(file)
      let bigSize = this.insPostBannerType ? 1024 : 500
      let str = this.insPostBannerType
        ? this.$t('messages.createCampaign.create149')
        : this.$t('messages.createCampaign.create150')
      if (size <= bigSize) {
        const img = new Image()
        const promise = new Promise((resolve, reject) => {
          img.onload = () => {
            const { width, height } = img
            if (
              this.insPostBannerType ||
              (!this.insPostBannerType && (width === 912 && height === 400))
            ) {
              resolve()
            } else {
              this.$message({
                type: 'error',
                message: `${this.$t('messages.createCampaign.create151')} ${str}.`,
                duration: 3000,
              })
              /* eslint-disable prefer-promise-reject-errors */
              reject()
            }
          }
        })
        img.src = url
        return promise
      } else {
        let suffix = this.insPostBannerType ? '1M' : '500K'
        this.$message({
          type: 'error',
          message: `${this.$t('messages.createCampaign.create145')} ${suffix}.`,
          duration: 3000,
        })
        return false
      }
    },
    handleProductImgChange(file, filelist) {
      if (this.insPostBannerType) {
        this.hidePostBannerUpload = filelist.length > 0
      } else {
        this.hideProductImgUpload = filelist.length > 0
      }
    },
    handleProductImgSuccess(response, file, filelist) {
      if (response.c !== 0) {
        filelist.splice(filelist.length - 1, 1)
        this.notifyOpen('Error', response.m, 'error')
        return
      }
      let len = filelist.length
      let newfilelist = [filelist[len - 1]]
      if (this.insPostBannerType) {
        this.bannerFileList = newfilelist
        this.form.post_banner = response.d.s3_link
        this.bannerFileList[0].url = response.d.s3_link
      } else {
        this.imgFileList = newfilelist
        this.form.img = response.d.s3_link
        this.imgFileList[0].url = response.d.s3_link
      }
    },
    handleProductImgRemove() {
      if (this.insPostBannerType) {
        this.bannerFileList = []
        this.form.post_banner = ''
        this.hidePostBannerUpload = false
      } else {
        this.imgFileList = []
        this.form.img = ''
        this.hideProductImgUpload = false
      }
    },
    handleReviewScreenshotBefore(file) {},
    handleReviewScreenshotChange(file, filelist) {
      this.hideReviewScreenshotUpload = filelist.length > 0
    },
    handleReviewScreenshotSuccess(response, file, filelist) {
      if (response.c !== 0) {
        filelist.splice(filelist.length - 1, 1)
        this.notifyOpen('Error', response.m, 'error')
        return
      }
      this.reviewScreenshotFileList = filelist
      this.form.review_screenshot = response.d.s3_link
    },
    handleReviewScreenshotRemove() {
      this.reviewScreenshotFileList = []
      this.form.review_screenshot = ''
      this.hideReviewScreenshotUpload = false
    },
    handleSamplePictureBefore(file) {},
    handleSamplePictureChange(file, filelist, item) {
      item.hideSamplePictureUpload = true
    },
    handleSamplePictureSuccess(response, file, filelist, item) {
      if (response.c !== 0) {
        filelist.splice(filelist.length - 1, 1)
        this.notifyOpen('Error', response.m, 'error')
        return
      }
      item.samplePictureFileList = filelist
      item.sample_picture = response.d.s3_link
    },
    handleSamplePictureRemove(file, fileList, item) {
      item.samplePictureFileList = []
      item.sample_picture = ''
      item.hideSamplePictureUpload = false
    },
    initOneImage(url, target) {
      if (!url) {
        return
      }
      this[target] = [{ url: url }]
    },
    initCommentsFile(url, target) {
      if (!url) {
        return
      }
      let name = url
      if (typeof url === 'string') {
        const arr = url.split('/')
        name = arr[arr.length - 1] || url
      }
      this[target] = [{ url: url, name }]
    },
    addKeyword(arr) {
      let obj = this.form.info[0]
      arr.push({
        keyword: '',
        daily_cap: obj.daily_cap,
        total_cap: obj.total_cap,
        sample_picture: '',
        samplePictureFileList: [],
        hideSamplePictureUpload: false,
      })
    },
    deleteKeyword(index, arr) {
      arr.splice(index, 1)
    },
    checkCap() {
      const rows = this.isCombo ? this.reviewComboList : this.reviewList
      const count = normalizeReviewRows(rows).length
      const info = this.isCombo
        ? this.collectComData().filter(item => Number(item.business_type) === 7)
        : this.form.info
      const total = info.reduce((sum, item) => sum + Number(item.total_cap), 0)
      this.showCapErr =
        (this.isCombo || this.reviewsTypesAndYtbCommentComputed) &&
        (!Number.isInteger(total) || total < 1 || total > count)
      return !this.showCapErr
    },
    // 报价和两个创建入口都读取当前全量评论，确认弹窗打开后修改也必须重新校验。
    validateReviewSubmission() {
      if (!this.checkReviews()) return false
      if (!this.checkCap()) {
        this.$message.error(this.$t('messages.createCampaign.create34'))
        return false
      }
      return true
    },
    changeTotalCap(value, index) {
      this.checkCap()
      if (this.scheduleDays - 1 >= 0 && value) {
        let total = value
        let obj = this.form.info[index]
        let daily_cap = Math.ceil(total / this.scheduleDays)
        obj.daily_cap = daily_cap
        this.$set(this.form.info, index, obj)
      }
    },
    changeDailyCap(value, item) {
      if (this.scheduleDays) {
        item.total_cap = this.scheduleDays * value
      } else {
        item.total_cap = 0
      }
    },
    getInfoTotalCap() {
      // end time实际时间为23:59:59, 所以日期差值加1
      this.form.info.forEach(item => {
        // business_type===7||business_type===11 9441
        if (this.reviewsTypesAndYtbCommentComputed) {
          this.changeReviewCap(this.form.info[0])
        } else {
          if (item.daily_cap) {
            item.total_cap = this.scheduleDays * item.daily_cap
          }
        }
      })
    },
    changePromotionDays(value) {
      this.getInfoTotalCap()
    },
    changeTimeSchedule(value) {
      if (value) {
        this.getInfoTotalCap()
      } else {
        this.$set(this.form, 'schedule', [])
        this.getInfoTotalCap()
      }
    },
    changeReview(val, index, popType) {
      let typeObj = this.reviewTypes[popType]
      let allList = typeObj.allList
      let page, pageSize
      if (popType === 'list') {
        page = this.$refs.reviewListRef[0].page
        pageSize = this.$refs.reviewListRef[0].pageSize
      } else {
        page = this.$refs.comboListRef.page3
        pageSize = this.$refs.comboListRef.pageSize
      }
      let obj = {
        value: val,
        showErr: false,
        tip: 'Error',
      }
      this.$set(this[allList], index + (page - 1) * pageSize, obj)
    },
    checkReviews() {
      let flag = true
      let type = this.isCombo ? 'combo' : 'list'
      if (type === 'combo' || (type === 'list' && this.reviewsTypesComputed)) {
        // Number(this.form.business_type)===7
        let typeObj = this.reviewTypes[type]
        let allList = typeObj.allList
        let str =
          type === 'list' ? this.$t('messages.other.other52') : this.$t('messages.other.other53')
        let revNum = 3000
        if (this.freeTrialUse) {
          revNum = 5
          if (this[allList].length !== this.form.info[0].daily_cap) {
            this.$message.error(this.$t('messages.tipError.limitErr5'))
            flag = false
            return flag
          }
        }
        if (this[allList].length > revNum) {
          // this.$message.error(`The number of ${str} cannot exceed ${revNum}!`)
          let ert = `${this.$t('messages.other.other50')}${str} ${this.$t(
            'messages.other.other51'
          )}} ${revNum}!`
          this.$message.error(ert)
          // this.$message.error(`The number of ${str} cannot exceed ${revNum}!`)
          flag = false
          return flag
        }
        let emptyTip = this.$t('messages.tipError.emptyErr2')
        let emptyErr = false
        let lenTip = this.$t('messages.tipError.limitErr3')
        let lenErr = false
        let repeatTip = this.$t('messages.other.other14')
        let repeatErr = false
        let charTip = this.$t('messages.tipError.limitErr4')
        let charErr = false
        this[allList].map(item => {
          // Excel 数值和历史数据与提交时使用相同的文本转换规则。
          const value = item.value == null ? '' : String(item.value).trim()
          item.tip = ''
          item.showErr = false
          if (!value) {
            item.tip = emptyTip
            item.showErr = true
            emptyErr = true
            flag = false
          }
          if (value.length > 500) {
            item.tip = lenTip
            item.showErr = true
            lenErr = true
            flag = false
          }
          if (value.includes(';')) {
            item.tip = charTip
            item.showErr = true
            charErr = true
            flag = false
          }
          return item
        })
        let arrs = Array.from(new Set(this.findDuplicateStrIndexes(this[allList])))
        if (arrs.length > 0) {
          repeatErr = true
          arrs.map(item => {
            this[allList][item].tip = repeatTip
            this[allList][item].showErr = true
            return item
          })
          flag = false
        }
        if (emptyErr) {
          this.$message.error(emptyTip)
        } else if (lenErr) {
          this.$message.error(lenTip)
        } else if (repeatErr) {
          this.$message.error(repeatTip)
        } else if (charErr) {
          this.$message.error(charTip)
        }
        this.handlePageList(type)
      }
      return flag
    },
    findDuplicateStrIndexes(arr, key = 'value') {
      const duplicateIndexes = []
      for (let i = 0; i < arr.length; i++) {
        const str = String(arr[i][key] == null ? '' : arr[i][key]).trim()
        for (let j = i + 1; j < arr.length; j++) {
          if (str && str === String(arr[j][key] == null ? '' : arr[j][key]).trim()) {
            // 找到相同的str值，将索引值存储到数组中
            duplicateIndexes.push(i, j)
          }
        }
      }

      return duplicateIndexes
    },
    validate() {
      // AAN-8092 :【自投平台】非JD支持国家暂时取消下单
      console.log('post-----')
      // if(!this.originalCountry.includes(this.form.country)){
      //   this.adsVisible = true;
      //   return;
      // }
      if (this.newCountryAndType) {
        this.supportInfoVisible = true
        return
      }
      this.$refs.createCampaign.validate((valid, data) => {
        let checkResult = this.validateReviewSubmission()
        let termNotPass = ((this.showTerm && !this.isCombo) || this.isCombo) && !this.termsCheck
        if (termNotPass) {
          this.showTermErr = true
          document.getElementById('elMain').scrollTop = 0
          let dom = document.getElementById('termsDiv')
          let scrollBody = document.getElementById('elMain')
          scrollBody.scrollTop = dom.offsetTop + 200
        }
        let comboCheck = true
        if (this.isCombo) {
          this.$refs.comboCampaign.validate((valid2, data2) => {
            comboCheck = valid2
          })
        }
        if (this.typeErr) {
          let msg = this.$t('messages.createCampaign.create72')
          this.$message.error(msg)
          return
        }
        if (valid && checkResult && !this.showCapErr && !termNotPass && comboCheck) {
          if (this.isCombo && this.goodReviewNumErr) {
            this.handleErrJump(checkResult)
            return
          }
          if (!this.isCombo && this.cusReviewNumErr) {
            this.$message.error(this.$t('messages.createCampaign.create99'))
            return
          }
          const params = this.getCheckParams()
          if (!this.freeTrialUse) {
            this.$http
              .post('/api/campaign/check/', params)
              .then(data => {
                this.checkCampaign = data.data
                // 新手创建不用作余额判断
                if (this.checkCampaign.need_recharge) {
                  this.balanceNotEnough = true
                } else {
                  this.balanceNotEnough = false
                }
                // 获取当前时间的时间戳
                // 比较当前时间戳和开始时间戳的大小
                this.handleShowTip()
                this.confirmVisible = true
              })
              .catch(error => {
                this.notifyOpen('Error', this.executeError(error), 'error')
              })
          } else {
            this.balanceNotEnough = false
            this.handleShowTip()
            this.confirmVisible = true
          }
        } else {
          this.handleErrJump(checkResult)
        }
      })
    },
    handleErrJump(checkResult) {
      // 校验不通过则定位到不通过的字段
      // 获取所有的校验字段
      var that = this
      let fields = this.$refs.createCampaign.fields
      let errFlag = fields.some(field => field.validateState === 'error')
      let scrollBody = document.getElementById('elMain')
      const jump = function(ids) {
        for (let i = 0, len = ids.length; i < len; i++) {
          let field = ids[i]
          // 如果校验状态为error
          if (field.validateState === 'error') {
            // 重置校验出错位置的offset
            that.errorOffset = 0
            // 重新获取offset
            that.getOffsetTop(field.$el)
            // 滚动到该位置
            let main = document.querySelector('.el-main')
            easeMoveTo(main, that.errorOffset - 200)
            return false
          }
        }
      }
      // 循环找出第一个校验出错的字段
      if (errFlag) {
        jump(fields)
        return
      }
      if (this.isCombo) {
        let fields2 = this.$refs.comboCampaign.fields
        let errFlag2 = fields2.some(field => field.validateState === 'error')
        if (errFlag2) {
          jump(fields2)
          return
        }
        if (!checkResult) {
          let dom = document.getElementById('combo-row-review')
          scrollBody.scrollTop = dom.offsetTop + 200
          return
        }
        if (this.goodReviewNumErr) {
          let dom = document.getElementById('err-tip')
          scrollBody.scrollTop = dom.offsetTop + 300
        }
      }
    },
    getLocalTime(i) {
      if (typeof i !== 'number') return
      var d = new Date()
      // 得到1970年一月一日到现在的秒数
      var len = d.getTime()
      // 本地时间与GMT时间的时间偏移差(注意：GMT这是UTC的民间名称。GMT=UTC）
      var offset = d.getTimezoneOffset() * 60000
      // 得到现在的格林尼治时间
      var utcTime = len + offset
      return new Date(utcTime + 3600000 * i)
    },
    handleShowTip() {
      if (this.form.schedule) {
        let todayDate = this.getLocalTime(Number(this.form.tz)).setHours(0, 0, 0, 0)
        let paramsDate = new Date(this.form.schedule[0]).setHours(0, 0, 0, 0)
        let isToday = todayDate === paramsDate
        let createTime = this.getLocalTime(Number(this.form.tz)).getHours()
        if (isToday && createTime >= 7) {
          this.rightNow = true
        } else {
          this.rightNow = false
        }
      }
    },
    getCheckParams() {
      let newInfo = this.form.info
      if (this.isCombo) {
        newInfo = this.collectComData()
      }
      const params = {
        country: this.form.country,
        business_type: this.form.business_type,
        info: JSON.stringify(newInfo),
        cp_type: this.form.cp_type,
        custom_review:
          this.isCombo || this.reviewsTypesAndYtbCommentComputed
            ? normalizeReviewRows(this.isCombo ? this.reviewComboList : this.reviewList)
                .map(row => row.value)
                .join(';')
            : '',
      }
      params.business_type = this.setRealBT()
      return params
    },
    generateParams() {
      let params = JSON.parse(JSON.stringify(this.form))
      // (business_type===7 || business_type===11) 9441
      if (this.reviewsTypesAndYtbCommentComputed && !this.isCombo) {
        params.custom_review = normalizeReviewRows(this.reviewList)
          .map(row => row.value)
          .join(';')
      } else {
        params.custom_review = ''
      }
      if (this.asoh5CountryAndType) {
        // 获取今天的开始时间（00:00:00）
        const startOfDay = moment()
          .startOf('day')
          .format('YYYY-MM-DD 00:00:00') // 默认格式为ISO 8601
        let count = 2 + this.form.promotion_days
        // 获取三天后的结束时间（23:59:59）
        const endOfDayInThreeDays = moment()
          .add(count, 'days')
          .endOf('day')
          .format('YYYY-MM-DD 23:59:59')
        params.start = startOfDay
        params.end = endOfDayInThreeDays
      } else {
        params.start = `${this.form.schedule[0]} 00:00:00`
        params.end = `${this.form.schedule[1]} 23:59:59`
      }
      let info = []
      if (this.isCombo) {
        info = this.collectComData()
        params.custom_review = normalizeReviewRows(this.reviewComboList)
          .map(row => row.value)
          .join(';')
      } else {
        info = this.form.info.map(item => {
          let { samplePictureFileList, hideSamplePictureUpload, ...newItem } = item
          return newItem
        })
      }
      if (
        this.isCombo ||
        (!this.isCombo &&
          this.form.business_type !== 2 &&
          !this.searchKeywordTypeSupport &&
          this.form.business_type !== 4)
      ) {
        info.map(item => {
          item.keyword = ''
          return item
        })
      }
      delete params.schedule
      if (this.mode === 'repeat') {
        delete params.id
      }
      params.info = JSON.stringify(info)
      let gl = this.form.country.toLowerCase()
      let hl = ''
      let newUrl = ''
      if (!this.mediaType && !this.socialMediaTypeComputed) {
        newUrl = this.form.app_store_url
        newUrl = this.changeURLArg(newUrl, 'gl', gl)
        if (gl === 'id') {
          hl = 'id'
        } else {
          hl = 'en'
        }
        newUrl = this.changeURLArg(newUrl, 'hl', hl)
      }
      params.app_store_url = newUrl
      if (!this.insPostBannerType) {
        params.post_banner = ''
      }
      params.campaign_new_user = Number(this.freeTrialUse)
      // params.campaign_new_user = this.$store.state.profile.campaign_new_user
      // params.business_type = this.form.business_type
      params.business_type = this.setRealBT()
      if (!this.isGuaranteedReview) {
        delete params.lang
        delete params.user_category
        delete params.product_feature
        delete params.attitude
      } else {
        params.lang = params.lang.toLowerCase()
      }
      return params
    },
    create: throttleFn(function() {
      this.$refs.createCampaign.validate(valid => {
        if (valid && this.validateReviewSubmission()) {
          this.createButtonLoading = true
          let params = this.generateParams()
          this.$http
            .post('/api/campaign/edit/', params)
            .then(data => {
              this.confirmVisible = false
              this.successVisible = true
              this.createButtonLoading = false
              this.notifyOpen(this.$t('messages.createCampaign.create201'))
              // 触发获取弹窗信息
              setTimeout(() => {
                this.$store.dispatch('getRealTimeInfo')
              }, 2000)
            })
            .catch(error => {
              this.createButtonLoading = false
              switch (error.c) {
                case -2001: // 余额不足
                  this.confirmVisible = false
                  this.failVisible = true
                  break
                default:
                  // network error
                  this.notifyOpen('Error', this.executeError(error), 'error')
              }
            })
        }
      })
    }, 3000),
    goDeposit() {
      this.confirmVisible = false
      let need = -this.checkCampaign.need
      window.open(`/deposit?need=${need}`, '_blank')
    },
    payItLater: throttleFn(function() {
      this.$refs.createCampaign.validate(valid => {
        if (valid && this.validateReviewSubmission()) {
          this.payLaterButtonLoading = true
          let params = this.generateParams()
          this.$http
            .post('/api/campaign/pay_it_later/', params)
            .then(data => {
              this.notifyOpen(this.$t('messages.createCampaign.create201'))
              this.$router.push(this.getCampaignListPath())
              // 触发获取弹窗信息
              setTimeout(() => {
                this.$store.dispatch('getRealTimeInfo')
              }, 2000)
            })
            .catch(error => {
              this.payLaterButtonLoading = false
              this.notifyOpen('Error', this.executeError(error), 'error')
            })
        }
      })
    }, 3000),
    getCampaignListPath() {
      return '/campaign/list'
    },
    viewCampaignList() {
      this.successVisible = false
      this.$router.push(this.getCampaignListPath())
    },
    calculateOrderPrice(value) {
      // 单位为美分
      const business_type = value.business_type
      const country = value.country
      let totalCap = 0
      value.info.forEach(item => {
        totalCap += item.total_cap
      })
      if (this.isOfflineTypeAllComputed && country && !this.isCombo) {
        if (totalCap) {
          let totalPrice = 0
          let price = this.offlineTypesPrice[this.realBusinessType][country]
          totalPrice = funCalc([totalCap, price], 2)
          this.orderPriceCal = totalPrice
          this.orderPriceCal2 = this.orderPriceCal.toFixed(2)
          console.log('this.realBusinessType', this.realBusinessType)
          console.log('price,totalCap,totalPrice', price, totalCap, totalPrice)
          console.log('orderPriceCal,orderPriceCal2', this.orderPriceCal, this.orderPriceCal2)
        } else {
          this.orderPriceCal = 0
          this.orderPriceCal2 = 0
        }
      } else if (this.newCountry || this.asoCountry) {
        let totalPrice = 0
        let arr = this.newCounTypes
        if (arr.includes(business_type) && totalCap) {
          let price = this.newCountryPrice[business_type][country]
          totalPrice = funCalc([totalCap, price], 2)
          this.orderPriceCal = totalPrice
          this.orderPriceCal2 = this.orderPriceCal.toFixed(2)
        } else {
          this.orderPriceCal = 0
          this.orderPriceCal2 = 0
        }
      } else if (!this.isCombo) {
        if (business_type && ((country && !this.mediaType) || this.mediaType) && totalCap) {
          let countryKey = this.otherCountry || this.mediaType ? 'Other' : country
          if (countryKey === 'Other' && (business_type === 4 || business_type === 5)) {
            this.orderPriceCal = 0
            this.orderPriceCal2 = 0
          } else {
            let index = business_type - 1
            let price = 0
            if (this.searchKeywordTypeSupport) {
              price = this.searchKeywordTypePriceRule[business_type][countryKey]
            } else {
              price = this.orderPriceRules[index][countryKey]
            }
            this.orderPriceCal = (totalCap * price) / 100
            this.orderPriceCal2 = this.orderPriceCal.toFixed(2)
          }
        } else {
          this.orderPriceCal = 0
          this.orderPriceCal2 = 0
        }
      } else if (this.isCombo) {
        let len = this.reviewLen
        if (this.totCap1 && this.totCap2 && country) {
          let totalPrice = 0
          totalPrice = funCalc(
            [this.comPrice1 * this.totCap1, this.comPrice2 * this.totCap2, this.comPrice3 * len],
            1
          )
          this.orderPriceCal = totalPrice
          this.orderPriceCal2 = this.orderPriceCal.toFixed(2)
        } else {
          this.orderPriceCal = 0
          this.orderPriceCal2 = 0
        }
      }
    },
    showBtnText() {
      if (this.mode === 'repeat') {
        return this.$t('messages.myCampaign.list1')
      } else {
        return this.$t('messages.myCampaign.list55')
      }
    },
    backToList() {
      this.$router.push(this.getCampaignListPath())
    },
    // 修改BusinessType时重置后面已填数据
    changeBusinessType(value) {
      // this.form.review_url = ''
      // this.form.reviewer_name = ''
      let obj = { ...this.form.info[0] }
      this.form.info = [obj]
    },
    getOffsetTop(ele) {
      if (ele.offsetTop !== undefined) {
        this.errorOffset += ele.offsetTop
      }
      if (ele.offsetParent !== document.body) {
        this.getOffsetTop(ele.offsetParent)
      }
    },
    cropAndResizeImage(img) {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      const originalWidth = img.width
      const originalHeight = img.height
      const originalRatio = originalWidth / originalHeight
      const targetRatio = this.targetWidth / this.targetHeight
      let cropWidth, cropHeight
      if (originalRatio > targetRatio) {
        // Width is greater, crop sides
        cropWidth = originalHeight * targetRatio
        cropHeight = originalHeight
      } else {
        // Height is greater, crop top and bottom
        cropWidth = originalWidth
        cropHeight = originalWidth / targetRatio
      }
      cropWidth = Math.min(cropWidth, originalWidth)
      cropHeight = Math.min(cropHeight, originalHeight)
      // yes
      canvas.width = cropWidth
      canvas.height = cropHeight
      ctx.drawImage(img, 0, 0, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight)
      // Convert canvas to DataURL
      let url = canvas.toDataURL('image/png')
      return url
    },
    async resizeImage(imageUrl, arr, index) {
      const img = new Image()
      img.crossOrigin = 'Anonymous'
      img.onload = () => {
        let url = this.cropAndResizeImage(img)
        arr[index] = url
      }
      img.src = imageUrl
    },
  },
  computed: {
    mannerTags() {
      if (this.isEnglish) {
        return this.mannerTagsEN
      }
      return this.mannerTagsCN
    },
    isEnglish() {
      return this.$i18n.locale === 'en'
    },
    businessTypeOptions() {
      if (this.isEnglish) {
        return this.initSelectOptions(businessType)
      }
      return this.initSelectOptions(businessTypeCN)
    },
    languageOptions() {
      if (this.isEnglish) {
        return this.initSelectOptions(languageAll)
      }
      return this.initSelectOptions(languageAllCN)
    },
    languageGuaranteedOptions() {
      if (this.isEnglish) {
        return this.initSelectOptions(languageGuaranteed)
      }
      return this.initSelectOptions(languageGuaranteedCN)
    },
    isGuaranteedReview() {
      return this.form.business_type === 14 && !this.isCombo
    },
    discounts() {
      let discount = this.baseDiscount
      let discount_type
      if (this.mode === 'detail') {
        discount_type = this.form.discount_type
      } else {
        discount_type = this.$store.state.profile.discount_type
      }

      let ratio = 100 - discount
      let ratioRate = ratio / 100
      return {
        discount,
        discount_type,
        ratio,
        ratioRate,
      }
    },
    comPriceDiscount1() {
      return this.getPriceOrTip('comPrice1')
    },
    comPriceTotal1() {
      return this.comPriceDiscount1 * this.totCap1
    },
    comPriceDiscountTip1() {
      return this.getPriceOrTip('comPrice1', 'comPriceDiscount1')
    },
    comPriceDiscount2() {
      return this.getPriceOrTip('comPrice2')
    },
    comPriceTotal2() {
      return this.comPriceDiscount2 * this.totCap2
    },
    comPriceDiscountTip2() {
      return this.getPriceOrTip('comPrice2', 'comPriceDiscount2')
    },
    comPriceDiscount3() {
      return this.getPriceOrTip('comPrice3')
    },
    comPriceTotal3() {
      return this.comPriceDiscount3 * this.reviewTotCap
    },
    comPriceDiscountTip3() {
      return this.getPriceOrTip('comPrice3', 'comPriceDiscount3')
    },
    comPriceTotal() {
      return funCalc([this.comPriceTotal1, this.comPriceTotal2, this.comPriceTotal3], 1)
    },
    sumTotalCap() {
      let sum = 0
      this.form.info.forEach(item => {
        if (item.total_cap) {
          sum += item.total_cap
        }
      })
      return sum
    },
    unitPrice() {
      let { business_type, country } = this.form
      let arr = this.typePrices[business_type]
      let sum = 0
      let countryKey = this.otherCountry || this.mediaType ? 'Other' : country
      if (!this.isCombo && this.isOfflineTypeAllComputed) {
        let price = this.offlineTypesPrice[this.realBusinessType][countryKey]
        sum = funCalc([price], 2)
      } else if (
        !this.isCombo &&
        this.searchKeywordTypeSupport &&
        this.form.business_type !== 2 &&
        this.form.business_type !== 4
      ) {
        let price = this.searchKeywordTypePriceRule[business_type][countryKey]
        sum = funCalc([price, 0.01], 2)
      } else {
        arr.map((item, i) => {
          let price = item[countryKey]
          // sum += price
          sum = funCalc([sum, price])
          return item
        })
      }
      return sum
    },
    unitPriceDiscount() {
      return this.getPriceOrTip('unitPrice')
    },
    unitPriceDiscountTip() {
      return this.getPriceOrTip('unitPrice', 'unitPriceDiscount')
    },
    unitPriceTotal() {
      return funCalc([this.unitPriceDiscount, this.sumTotalCap], 2)
    },
    unitPriceTotalTip() {
      return `$${this.unitPriceDiscount} * ${this.sumTotalCap} = $${this.unitPriceTotal}`
    },
    countryOptionsCom() {
      // let arr = []
      // this.countryOptions.map(item => {
      //   let original = this.originalCountry.includes(item.id)
      //   let originalNew = this.originalNewCountry.includes(item.id)
      //   let asoh5 = this.asoh5Country.includes(item.id)
      //   if(this.isCombo){
      //     if(original){
      //       arr.push(item)
      //     }
      //   }else if(!this.isCombo && !this.mediaType){
      //     let { business_type } = this.form
      //     // 3,7=>
      //     if(this.newCounTypes.includes(business_type)){
      //       if(original || originalNew || asoh5){
      //         arr.push(item)
      //       }
      //     }else if(original){
      //       arr.push(item)
      //     }
      //   }
      //   return item
      // })
      // return arr
      // return this.countryAllOptions
      if (this.isEnglish) {
        return this.initSelectOptions(countrySupport)
      }
      return this.initSelectOptions(countrySupportCN)
    },
    searchKeywordTypeSupport() {
      return this.searchKeywordType && this.keywordsInstall
    },
    searchKeywordType() {
      return (
        this.searchKeywordsType.includes(this.form.business_type) &&
        this.originalCountry.includes(this.form.country) &&
        !this.BDAndPK.includes(this.form.country)
      )
    },
    resizeScreenshots() {
      let arr = []
      let len = this.screenshots.length
      this.screenshots.map((item, index) => {
        if (index >= len - 5 && len >= 5) {
          arr.push(item)
        } else {
          arr.push(item)
          this.resizeImage(item, arr, index)
        }
        return item
      })
      return arr
      // return this.screenshots
    },
    baseDiscount() {
      // create,repeat => this.$store.state.profile.discount; detail; => campaign.real_time_discount
      if (this.mode === 'detail') {
        return this.form.real_time_discount
      } else {
        return this.$store.state.profile.discount
      }
    },
    orderPriceCalTip() {
      let { discount, discount_type, ratio } = this.discounts
      let str = ''
      if (discount === 0 && discount_type === 0) {
        str = `$${this.orderPriceCal}`
      } else {
        str = `$${this.orderPriceCal} * ${ratio}% = $${this.orderPriceCalDiscount}`
      }
      return str
    },
    orderPriceCalDiscount() {
      // 处理折扣后的总价
      let { ratioRate } = this.discounts
      let price = (this.orderPriceCal * ratioRate).toFixed(2)
      return price
    },
    timeBefore() {
      let flag = this.compareTime(this.bfTime)
      return flag
    },
    typeErr() {
      return this.freeTrialUse && (this.isCombo || this.mediaType)
    },
    freeTrialUse() {
      return Boolean(this.$store.state.profile.campaign_new_user) && this.freeTrial
    },
    isCombo() {
      return this.form.cp_type === 1
    },
    insPostType() {
      const { business_type } = this.form
      return business_type === 9 && !this.isCombo
    },
    insPostBannerType() {
      return this.insPostType || this.insAndYtbFollowComputed
    },
    socialMediaTypeComputed() {
      const { business_type } = this.form
      return this.socialMediaTypes.includes(business_type) && !this.isCombo
    },
    mediaType() {
      const { business_type } = this.form
      return this.mediaTypes.includes(business_type)
    },
    orderPriceCalCombo: {
      get: function() {
        let len = this.reviewLen
        let { country } = this.form
        if (this.totCap1 && this.totCap2 && country) {
          let totalPrice = 0
          totalPrice = funCalc(
            [this.comPrice1 * this.totCap1, this.comPrice2 * this.totCap2, this.comPrice3 * len],
            1
          )
          return totalPrice
        } else {
          return 0
        }
      },
      set: function() {},
    },
    orderPriceNewCountry: {
      get: function() {
        let totalPrice = 0
        let arr = this.newCounTypes
        let { business_type, country, info } = this.form
        let totalCap = 0
        info.forEach(item => {
          totalCap += item.total_cap
        })
        if ((this.newCountry || this.asoCountry) && arr.includes(business_type) && totalCap) {
          let price = this.newCountryPrice[business_type][country]
          totalPrice = funCalc([totalCap, price], 2)
        }
        return totalPrice
      },
      set: function() {},
    },
    comPrice1() {
      const { country } = this.form
      let countryKey = this.otherCountry ? 'Other' : country
      let item = this.typeComboPrices[1][0]
      return item[countryKey].toFixed(2)
    },
    comPrice2() {
      const { country } = this.form
      let countryKey = this.otherCountry ? 'Other' : country
      let item = this.typeComboPrices[3][0]
      return item[countryKey].toFixed(2)
    },
    comPrice3() {
      const { country } = this.form
      let countryKey = this.otherCountry ? 'Other' : country
      let item = this.typeComboPrices[7][0]
      return item[countryKey].toFixed(2)
    },
    totCap1: {
      get: function() {
        let { cap1, cap2 } = this.combo
        let cap
        if (this.use_total_price_discount) {
          cap = cap1
        } else {
          cap = cap1 - cap2
        }
        if (!isInteger(cap) || cap <= 0) return 0
        return cap * this.scheduleDays
      },
      set: function() {},
    },
    totCap2: {
      get: function() {
        let { cap2 } = this.combo
        let cap
        if (this.use_total_price_discount) {
          cap = cap2
        } else {
          cap = cap2 - this.reviewLen
        }
        if (!isInteger(cap) || cap <= 0) return 0
        return cap * this.scheduleDays
      },
      set: function() {},
    },
    reviewTotCap() {
      return this.reviewLen * this.scheduleDays
    },
    reviewLen() {
      return normalizeReviewRows(this.reviewComboList).length
    },
    orderPrice() {
      const { business_type, country, info, media_target, media_platform } = this.form
      let scheduleDays = this.scheduleDays
      let { cap1, cap2 } = this.combo
      let reviewComboList = this.reviewComboList
      let keywordsInstall = this.keywordsInstall
      return {
        business_type,
        country,
        info,
        cap1,
        cap2,
        reviewComboList,
        keywordsInstall,
        scheduleDays,
        media_target,
        media_platform,
      }
    },
    popTotal() {
      let num = 0
      if (this.cardIndex === 'card1') {
        num = this.reviewPopList.length
        return num
      } else {
        let arr = this.popReview.split(/[.;]/)
        arr.map(item => {
          if (item !== '') {
            num = num + 1
          }
        })
        return num
      }
    },
    jdCountry() {
      if (!this.form.country) {
        return false
      }
      let flag = this.originalCountry.includes(this.form.country)
      return flag
    },
    otherCountry() {
      if (!this.form.country) {
        return false
      }
      let flag = this.originalCountry.indexOf(this.form.country) < 0
      return flag
    },
    asoCountry() {
      if (!this.form.country) {
        return false
      }
      let flag = this.asoh5Country.includes(this.form.country)
      return flag
    },
    newCountry() {
      if (!this.form.country) {
        return false
      }
      let flag = this.originalNewCountry.includes(this.form.country)
      return flag
    },
    showTerm() {
      const type = this.form.business_type
      return type === 3 || type === 4 || type === 7 || type === 14 || type === 15
    },
    totalCap: {
      get: function() {
        let { cap1, cap2 } = this.combo
        let len = this.reviewLen
        return parseInt((cap1 + cap2) * this.scheduleDays + len)
      },
      set: function() {},
    },
    goodReviewNumErr: {
      get: function() {
        if (this.isCombo) {
          let { cap2 } = this.combo
          let len = this.reviewLen
          let ratingsCap = cap2 * this.scheduleDays
          if (len > ratingsCap) {
            return 'capErr'
          } else if (len < this.scheduleDays) {
            return 'dayErr'
          } else {
            return false
          }
        } else {
          return false
        }
      },
      set: function() {},
    },
    cusReviewNumErr() {
      // let business_type = Number(this.form.business_type) 9441
      if (!this.isCombo && this.reviewsTypesAndYtbCommentComputed) {
        // (business_type === 7 || business_type === 11)
        let len = this.reviewList.length
        if (len < this.scheduleDays) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    newCountryAndType() {
      const { business_type, cp_type } = this.form
      return cp_type === 0 && this.newCountry && this.newCounTypes.includes(business_type)
    },
    asoh5CountryAndType() {
      const { business_type, cp_type } = this.form
      return cp_type === 0 && this.asoCountry && this.newCounTypes.includes(business_type)
    },
    scheduleDays() {
      let days = 0
      let scheduleDay = 0
      let { schedule, promotion_days, country } = this.form
      if (this.jdCountry || country === '') {
        if (schedule) {
          scheduleDay = dayjs(schedule[1]).diff(schedule[0], 'day', true)
          days = Math.ceil(scheduleDay) + 1
        } else {
          days = 1
        }
      } else {
        days = promotion_days
      }
      return days
    },
    reviewsTypesComputed() {
      const { business_type } = this.form
      return this.reviewsTypes.includes(business_type) && !this.isCombo
    },
    reviewsTypesAndYtbCommentComputed() {
      const { business_type } = this.form
      return this.reviewsTypesAndYtbComment.includes(business_type) && !this.isCombo
    },
    fiveTypesComputed() {
      const { business_type } = this.form
      return this.fiveTypes.includes(business_type) && !this.isCombo
    },
    commentTargetComputed() {
      const { media_target } = this.form
      return media_target === this.mediaTargetComment
    },
    mediaTargetOptionsComputed() {
      const { media_platform } = this.form
      let arr = []
      let platforms = [3, 4, 5]
      let options = this.asoGrowOption.asogrow_media_target
      if (platforms.includes(media_platform) || media_platform === '') {
        arr = options
      } else if (media_platform === this.mediaPlatformGM) {
        arr = options.filter(v => v.id === this.mediaTargetComment)
      } else if (media_platform === this.mediaPlatformYtb) {
        arr = options.filter(v => v.id !== this.mediaTargetPostLike)
      } else {
        arr = options.filter(v => v.id !== this.mediaTargetComment)
      }
      return arr
    },
    socailMediaInsOrYtbFollow() {
      const { media_platform, media_target } = this.form
      let arr = [1, 2]
      return (
        arr.includes(media_platform) &&
        media_target === 1 &&
        !this.isCombo &&
        this.socialMediaTypeComputed
      )
    },
    insAndYtbFollowComputed() {
      const { media_platform, media_target } = this.form
      return (
        media_platform === 1 && media_target === 2 && !this.isCombo && this.socialMediaTypeComputed
      )
    },
    isOfflineTypeComputed() {
      const { business_type } = this.form
      return this.offlineTypes.includes(business_type) && !this.isCombo
    },
    isOfflineTypeAllComputed() {
      const { business_type } = this.form
      return this.offlineTypesAll.includes(business_type) && !this.isCombo
    },
    realBusinessType() {
      let realType = this.form.business_type
      if (this.socialMediaTypeComputed) {
        let { media_platform, media_target } = this.form
        if (media_target === 3) {
          if (media_platform === 6) {
            realType = 19
          } else {
            realType = 18
          }
        } else if (media_target === 1) {
          realType = 16
        } else {
          realType = 17
        }
      }
      return realType
    },
    showMediaComment() {
      let { media_platform, media_target } = this.form
      let flag = false
      if (media_platform !== 1 && media_target === 3) {
        flag = true
      }
      return this.socialMediaTypeComputed && flag
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      if (oldVal && newVal !== oldVal) {
        this.syncAttitudeOnLocaleChange(oldVal)
        this.refreshFormValidateOnLocaleChange(this, [
          'createCampaign',
          'comboCampaign',
          'aiReviewRef',
        ])
        this.refreshReviewListErrorsOnLocaleChange()
      }
    },
    isEnglish: {
      handler(newVal) {
        if (newVal) {
          this.asoGrowOption = this.asoGrowOptionEN
        } else {
          this.asoGrowOption = this.asogrowCN
        }
      },
      immediate: true,
    },
    timeBefore: {
      handler(newVal) {
        if (newVal) {
          this.typePrices = this.typePrice
          this.typeComboPrices = this.typeComboPrice
          this.orderPriceRules = this.orderPriceRule
        } else {
          this.typePrices = this.typeNewPrice
          this.orderPriceRules = this.orderPriceNewRule
          if (this.use_total_price_discount) {
            this.typeComboPrices = this.typeComboNewPrice
          } else {
            this.typeComboPrices = this.typeComboDiscountPrice
          }
        }
      },
      immediate: true,
    },
    freeTrialUse: {
      handler(newVal) {
        // 处理新手试用逻辑
        if (newVal) {
          // 设置默认值，且不能修改
          const today = moment().format('YYYY-MM-DD')
          this.form.schedule = [today, today]
          // Business Type仅支持Single Business - ASO类型任务
          this.$set(this.form, 'cp_type', 0)
          this.$set(this.form, 'business_type', 1)
          let obj = this.form.info[0]
          obj.daily_cap = 5
          this.changeDailyCap(obj.daily_cap, obj)
        }
      },
      deep: true,
      immediate: false,
    },
    $route: function() {
      this.initPage()
    },
    orderPrice: {
      handler(newVal) {
        this.calculateOrderPrice(newVal)
      },
      deep: true,
      immediate: true,
    },
    'form.business_type': {
      handler(newVal, oldVal) {
        let arr = []
        if (newVal !== 2 && newVal !== 4) {
          arr = [this.form.info[0]]
        } else {
          arr = this.form.info
        }
        arr.map((item, index) => {
          let obj = { ...item }
          oldVal = Number(oldVal)
          newVal = Number(newVal)
          // 9441
          if (this.reviewsTypesAndYtbComment.includes(oldVal)) {
            // oldVal === 7|| oldVal=== 11
            obj.daily_cap = 10
            this.changeDailyCap(obj.daily_cap, obj)
          }
          if (this.reviewsTypesAndYtbComment.includes(newVal)) {
            // newVal === 7|| newVal=== 11
            this.changeReviewCap(obj)
          }
          if (this.freeTrialUse && this.reviewsTypes) {
            // newVal === 7
            obj.daily_cap = 5
            this.changeDailyCap(obj.daily_cap, obj)
          }
          // this.form.info[index] = obj
        })
        this.form.info = [...arr]
        if (!newVal) {
          this.$set(this.form, 'cp_type', 1)
        } else {
          this.$set(this.form, 'cp_type', 0)
        }
      },
      deep: true,
    },
    '$store.state.introStepInfo.currentStep': {
      handler(newVal, oldVal) {
        if (parseInt(sessionStorage.getItem('complete_guide'))) return
        if (newVal === 4 && oldVal === 5) {
          this.$store.state.introStepInfo.currentStep = 4
          sessionStorage.setItem('currentStep', 4)
          this.$router.push('/snapshot')
        }
        if (newVal === 5) {
          this.$set(this.form, 'cp_type', 0)
          this.$nextTick(() => {
            guide([
              {
                title: this.$t('messages.guide.guide4'),
                intro: `${this.$t('messages.guide.guide5')}(5/7)`,
                element: document.querySelector('#guide-step5'),
              },
            ])
          })
        } else {
          this.$set(this.form, 'cp_type', 1)
        }
      },
      deep: true,
      immediate: true,
    },
    newCountryAndType: {
      handler(newVal) {
        if (newVal) {
          this.supportInfoVisible = true
        }
      },
      deep: true,
    },
    imgFileList(newVal, oldVal) {
      // 你的回调函数逻辑
      this.resizedImageFileList = []
      if (newVal.length > 0) {
        newVal.map((item, index) => {
          this.resizedImageFileList.push(item)
          const img = new Image()
          img.crossOrigin = 'Anonymous'
          img.onload = () => {
            let url = this.cropAndResizeImage(img)
            this.resizedImageFileList[index].url = url
          }
          img.src = item.url
        })
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      document.getElementById('elMain').scrollTop = 0
    })
    this.initPage()
  },
}
